/* eslint-disable @typescript-eslint/no-this-alias */
(function prophecySdk(global) {
  "use strict";

  var VERSION = "1.2.2";
  var DEFAULT_ENDPOINT = "https://demo.orbital.vision";

  /**
   * The filling ring, and optionally the running time beside it.
   *
   * `id` names the generation it is counting. More than one can be running at
   * once, so a clock that did not say which one it was would show whichever
   * finished last.
   */
  function generationClockMarkup(showTime, id) {
    return (
      '<div class="generation-clock" aria-hidden="true"' +
      (id ? ' data-generation="' + id + '"' : "") +
      '><svg viewBox="0 0 80 80">' +
      '<circle class="generation-track" cx="40" cy="40" r="35" pathLength="100"></circle>' +
      '<circle class="generation-progress" cx="40" cy="40" r="35" pathLength="100"></circle>' +
      "</svg>" +
      (showTime ? '<span class="generation-time">0s</span>' : "") +
      "</div>"
    );
  }

  function generatingMarkup(title, copy, id) {
    return (
      '<div class="generating-inner">' +
      generationClockMarkup(true, id) +
      '<h3 class="generating-title">' +
      title +
      "</h3>" +
      '<p class="generating-copy">' +
      copy +
      "</p></div>"
    );
  }

  var OVERLAY_STYLES = [
    ":host{all:initial}",
    "*{box-sizing:border-box;font-family:Inter,ui-sans-serif,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif}",
    ".overlay{position:fixed;z-index:2147482000;display:flex;justify-content:flex-end;pointer-events:none}",
    ".overlay > *{pointer-events:auto}",
    // Every element here sets its own display, which beats the browser's own
    // [hidden] rule, so hiding one has to say so explicitly.
    "[hidden]{display:none !important}",
    "@media(max-width:640px){.pill{font-size:11px;padding:8px 13px}.overlay{top:auto}}",
    ".pill{display:inline-flex;align-items:center;gap:8px;max-width:100%;padding:9px 15px;border:1px solid rgba(0,0,0,.1);border-radius:999px;background:#fff;color:#111;font:600 12px/1.2 inherit;letter-spacing:.01em;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,.12);transition:background-color 150ms cubic-bezier(.23,1,.32,1),transform 120ms cubic-bezier(.23,1,.32,1)}",
    ".pill:active{transform:scale(.97)}",
    "@media(hover:hover) and (pointer:fine){.pill:hover{background:#f4f4f5}}",
    ".pill:focus-visible{outline:2px solid #111;outline-offset:2px}",
    ".pill span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
    ".stack{position:relative;display:inline-block}",
    ".corner{position:absolute;left:96px;top:6px;display:flex;align-items:center;justify-content:center;width:26px;height:26px;padding:0;border:1px solid rgba(0,0,0,.1);border-radius:999px;background:#fff;color:#111;box-shadow:0 1px 3px rgba(0,0,0,.12);transform:translate(-50%,-50%);z-index:2;cursor:pointer;transition:transform 160ms cubic-bezier(.23,1,.32,1),background-color 150ms cubic-bezier(.23,1,.32,1)}",
    ".corner[data-state=busy],.corner[data-state=done]{cursor:default}",
    ".corner:disabled{cursor:default;opacity:.45}",
    ".corner:active{transform:translate(-50%,-50%) scale(.94)}",
    ".corner[data-state=busy]:active,.corner[data-state=done]:active{transform:translate(-50%,-50%)}",
    "@media(hover:hover) and (pointer:fine){.corner[data-state=add]:hover{background:#f4f4f5}}",
    ".corner:focus-visible{outline:2px solid #111;outline-offset:2px}",
    // Every face lives in the button at once and is faded between, so the
    // control is one object changing rather than three swapping places.
    ".face{position:absolute;display:flex;align-items:center;justify-content:center;width:15px;height:15px;opacity:0;transform:scale(.72);transition:opacity 160ms cubic-bezier(.23,1,.32,1),transform 160ms cubic-bezier(.23,1,.32,1)}",
    ".face svg{width:15px;height:15px}",
    ".face .generation-clock{width:15px;height:15px}",
    ".corner[data-state=add] .face-add,.corner[data-state=busy] .face-busy,.corner[data-state=done] .face-done{opacity:1;transform:scale(1)}",
    "@media(prefers-reduced-motion:reduce){.face{transition-duration:0ms}}",
    ".done{animation:prophecy-pop 260ms cubic-bezier(.23,1,.32,1)}",
    ".done circle{fill:none;stroke:rgba(0,0,0,.12);stroke-width:6}",
    ".done path{fill:none;stroke:#111;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:44;stroke-dashoffset:44;animation:prophecy-tick 340ms cubic-bezier(.23,1,.32,1) 60ms forwards}",
    "@keyframes prophecy-tick{to{stroke-dashoffset:0}}",
    "@keyframes prophecy-pop{from{transform:scale(.9);opacity:0}to{transform:scale(1);opacity:1}}",
    "@media(prefers-reduced-motion:reduce){.done{animation:none}.done path{animation-duration:0ms;stroke-dashoffset:0}}",
    ".add{display:inline-flex;align-items:center;justify-content:center;width:42px;height:42px;padding:0;border:1px solid rgba(0,0,0,.1);border-radius:999px;background:#fff;color:#111;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,.12);transition:background-color 150ms cubic-bezier(.23,1,.32,1),transform 120ms cubic-bezier(.23,1,.32,1)}",
    ".add:active{transform:scale(.94)}",
    "@media(hover:hover) and (pointer:fine){.add:hover{background:#f4f4f5}}",
    ".add:focus-visible{outline:2px solid #111;outline-offset:2px}",
    ".solo{display:inline-flex;align-items:center;justify-content:center;width:42px;height:42px;padding:0;border:1px solid rgba(0,0,0,.1);border-radius:999px;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12)}",
    ".solo .generation-clock,.solo svg{width:26px;height:26px}",
    ".generation-clock{position:relative}",
    ".busy svg{transform:rotate(-90deg)}",
    ".generation-track{fill:none;stroke:rgba(0,0,0,.12);stroke-width:8}",
    ".generation-progress{fill:none;stroke:#111;stroke-width:8;stroke-linecap:round;stroke-dasharray:100;stroke-dashoffset:100;transition:stroke-dashoffset 120ms linear}",
    ".cards{position:relative;display:block;width:108px;height:78px;padding:0;border:0;background:none;cursor:pointer;transition:transform 200ms cubic-bezier(.23,1,.32,1)}",
    ".card{position:absolute;width:96px;height:72px;left:0;top:6px;border-radius:10px;overflow:hidden;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.16);background:#f4f4f5;transition:transform 200ms cubic-bezier(.23,1,.32,1)}",
    ".card img{display:block;width:100%;height:100%;object-fit:cover}",
    ".card.fresh{animation:prophecy-card-in 320ms cubic-bezier(.23,1,.32,1)}",
    "@keyframes prophecy-card-in{from{transform:translate(14px,-8px) scale(.94);opacity:0}to{transform:translate(0,0) scale(1);opacity:1}}",
    "@media(prefers-reduced-motion:reduce){.card.fresh{animation:none}}",
    ".card.behind-1{transform:translate(6px,-3px) scale(.96);opacity:.85}",
    ".card.behind-2{transform:translate(12px,-6px) scale(.92);opacity:.6}",
    "@media(hover:hover) and (pointer:fine){",
    ".cards:hover{transform:scale(1.05)}",
    ".cards:hover .card.behind-1{transform:translate(9px,-5px) scale(.96)}",
    ".cards:hover .card.behind-2{transform:translate(18px,-10px) scale(.92)}",
    "}",
    ".cards:active{transform:scale(.97)}",
    "@media(prefers-reduced-motion:reduce){.pill,.cards{transition-duration:0ms}}",
  ].join("");

  /**
   * A fingerprint of the room photo's own bytes.
   *
   * An id only identifies the record we happened to create, so the same
   * photograph uploaded twice, or restored into a fresh page, looks like a
   * different room and gets generated against again. The bytes do not change.
   */
  async function roomPhotoFingerprint(blob) {
    try {
      if (!global.crypto || !global.crypto.subtle) return null;
      var buffer = await blob.arrayBuffer();
      var digest = await global.crypto.subtle.digest("SHA-256", buffer);
      var bytes = Array.from(new Uint8Array(digest)).slice(0, 12);
      return bytes
        .map(function (byte) {
          return byte.toString(16).padStart(2, "0");
        })
        .join("");
    } catch (_) {
      // Not available over plain HTTP, and not worth failing a preview for.
      return null;
    }
  }

  /**
   * Where the API lives when nothing says otherwise.
   *
   * Only an OV25 developer, whose configurator is itself on localhost, wants
   * the page's own origin. A retailer working on localhost against the real
   * configurator still needs the real API, so their host alone is not enough.
   */
  function defaultEndpoint(iframe) {
    if (
      isDevelopmentHost() &&
      isDevelopmentConfigurator(iframe) &&
      global.location &&
      global.location.origin
    ) {
      return global.location.origin;
    }
    return DEFAULT_ENDPOINT;
  }
  var ASPECT_RATIOS = ["1:1", "3:2", "4:3", "16:9", "2:3", "3:4", "9:16"];
  var PHOTO_DB_NAME = "orbital-room-ai";
  var PHOTO_STORE_NAME = "room-photos";
  var PHOTO_MAX_AGE_MS = 24 * 60 * 60 * 1000;
  var RECENT_PHOTO_MAX_COUNT = 10;
  var HISTORY_MAX_IMAGE_BYTES = 12 * 1024 * 1024;
  var HISTORY_TOTAL_IMAGE_BYTES = 48 * 1024 * 1024;
  var PREVIEW_MAX_AGE_MS = 24 * 60 * 60 * 1000;
  var PREVIEW_MAX_COUNT = 4;
  // Exact SVG exported from OV Website 2026, Figma node 2001:666.
  var ORBITAL_VISION_LOGO_MASK =
    'url("data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9Ijc5LjE2OTMiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCA3OS4xNjkzIDM4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBpZD0iR3JvdXAgMTMyMTMxNTQ1NSI+CjxwYXRoIGlkPSJWZWN0b3IgMSIgZD0iTTM0LjgzNTkgMEg3OS4xNjkzTDU2LjU1MDIgMzhMMzQuODM1OSAwWiIgZmlsbD0iYmxhY2siLz4KPGVsbGlwc2UgaWQ9IkVsbGlwc2UgMSIgY3g9IjE5IiBjeT0iMTkiIHJ4PSIxOSIgcnk9IjE5IiBmaWxsPSJibGFjayIvPgo8L2c+Cjwvc3ZnPgo=")';
  // Hyperbolic progress: exactly halfway at 10 seconds, then progressively
  // slower without falsely reaching 100% before the generation really ends.
  var GENERATION_PROGRESS_HALF_LIFE_MS = 10 * 1000;
  var MAX_PRODUCT_IMAGES = 4;
  // How long to keep waiting for the scene to report itself settled. The
  // configurator gives up chasing a clean frame after five seconds, so this
  // sits past that: it is a stop against a message that never comes, not a
  // guess at how long a fabric takes to load.
  var SCENE_SETTLE_TIMEOUT_MS = 8 * 1000;
  var instances = 0;
  var pageLockCount = 0;
  var previousBodyOverflow = "";

  function sdkError(message, code) {
    var error = new Error(message);
    error.code = code || "ROOM_AI_ERROR";
    return error;
  }

  function element(value, label) {
    var result =
      typeof value === "string" ? document.querySelector(value) : value;
    if (!result)
      throw sdkError(
        "Room AI could not find " + label + ".",
        "ELEMENT_NOT_FOUND",
      );
    return result;
  }

  function isDevelopmentHost() {
    var hostname = String(global.location && global.location.hostname || "").toLowerCase();
    return (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname === "::1" ||
      hostname.endsWith(".localhost")
    );
  }

  function isDevelopmentConfigurator(iframe) {
    if (!iframe || iframe.tagName !== "IFRAME") return false;
    if (!iframe.getAttribute("src")) return false;
    try {
      var url = new URL(iframe.src, global.location.href);
      return (
        (url.protocol === "http:" || url.protocol === "https:") &&
        (url.hostname === "localhost" ||
          url.hostname === "127.0.0.1" ||
          url.hostname.endsWith(".localhost"))
      );
    } catch (_) {
      return false;
    }
  }

  function isOv25Configurator(iframe) {
    if (!iframe || iframe.tagName !== "IFRAME") return false;
    if (!iframe.getAttribute("src")) return false;
    try {
      var url = new URL(iframe.src, global.location.href);
      return (
        url.protocol === "https:" &&
        url.hostname === "configurator.orbital.vision"
      );
    } catch (_) {
      return false;
    }
  }

  function anyConfigurator(node, development) {
    if (isOv25Configurator(node)) return true;
    if (development && isDevelopmentConfigurator(node)) return true;
    if (!node || !node.querySelectorAll) return false;
    var frames = node.querySelectorAll("iframe");
    for (var i = 0; i < frames.length; i += 1) {
      if (isOv25Configurator(frames[i])) return true;
      if (development && isDevelopmentConfigurator(frames[i])) return true;
    }
    return false;
  }

  function resolveConfigurator(value, development) {
    if (value) {
      var configured = element(value, "the configurator iframe");
      if (configured.tagName !== "IFRAME")
        throw sdkError("The configurator option must point to an iframe.");
      if (
        !isOv25Configurator(configured) &&
        !(development && isDevelopmentConfigurator(configured))
      )
        throw sdkError(
          "The configurator must be an HTTPS iframe from configurator.orbital.vision.",
          "INVALID_CONFIGURATOR",
        );
      return configured;
    }
    return (
      Array.from(document.querySelectorAll("iframe")).find(function (frame) {
        return (
          isOv25Configurator(frame) ||
          (development && isDevelopmentConfigurator(frame))
        );
      }) || null
    );
  }

  function normalizeProductReference(value, productId) {
    var reference =
      value === undefined || value === null ? "" : String(value).trim();
    if (!reference && Number.isInteger(productId)) reference = String(productId);
    if (reference.length > 200)
      throw sdkError(
        "productReference must be 200 characters or fewer.",
        "INVALID_PRODUCT_REFERENCE",
      );
    return reference;
  }

  function normalizeProductImageSources(value) {
    if (value === undefined || value === null) return [];
    if (!Array.isArray(value) || value.length < 1 || value.length > MAX_PRODUCT_IMAGES) {
      throw sdkError(
        "productImages must contain between one and four images.",
        "INVALID_PRODUCT_IMAGES",
      );
    }
    return value.map(function (source) {
      if (source instanceof Blob) {
        if (
          !/^image\/(jpeg|png|webp)$/.test(source.type || "") ||
          !source.size ||
          source.size > HISTORY_MAX_IMAGE_BYTES
        ) {
          throw sdkError(
            "Each product image must be a JPEG, PNG or WebP image up to 12MB.",
            "INVALID_PRODUCT_IMAGE",
          );
        }
        return source;
      }
      if (typeof source !== "string" || !source.trim()) {
        throw sdkError(
          "Each product image must be a Blob or an HTTP(S) URL.",
          "INVALID_PRODUCT_IMAGE",
        );
      }
      var url;
      try {
        url = new URL(source, global.location.href);
      } catch (_) {
        throw sdkError("A product image URL is invalid.", "INVALID_PRODUCT_IMAGE");
      }
      if (url.protocol !== "https:" && url.protocol !== "http:") {
        throw sdkError(
          "Product image URLs must use HTTP or HTTPS.",
          "INVALID_PRODUCT_IMAGE",
        );
      }
      return url.href;
    });
  }

  async function productImageSourceToBlob(source) {
    if (source instanceof Blob) return source;
    var response = await fetch(source, { credentials: "same-origin" });
    if (!response.ok) {
      throw sdkError(
        "A product image could not be downloaded. Check its URL and CORS policy.",
        "PRODUCT_IMAGE_FETCH_FAILED",
      );
    }
    var contentLength = Number(
      response.headers && response.headers.get("content-length"),
    );
    if (Number.isFinite(contentLength) && contentLength > HISTORY_MAX_IMAGE_BYTES) {
      throw sdkError(
        "A product image is larger than 12MB.",
        "PRODUCT_IMAGE_TOO_LARGE",
      );
    }
    var blob = await response.blob();
    if (
      !/^image\/(jpeg|png|webp)$/.test(blob.type || "") ||
      !blob.size ||
      blob.size > HISTORY_MAX_IMAGE_BYTES
    ) {
      throw sdkError(
        "Each product image must be a JPEG, PNG or WebP image up to 12MB.",
        "INVALID_PRODUCT_IMAGE",
      );
    }
    return blob;
  }

  function parseConfiguratorUrl(iframe, options) {
    var url = iframe ? new URL(iframe.src, global.location.href) : null;
    var segments = url ? url.pathname.split("/").filter(Boolean) : [];
    var apiKey = options.apiKey || segments[0] || "";
    var organizationValue = String(apiKey).split("-")[0] || null;
    var parsedOrganizationId = Number(organizationValue);
    var organizationId =
      Number.isInteger(parsedOrganizationId) && parsedOrganizationId > 0
        ? parsedOrganizationId
        : null;
    var pathProductId = Number(segments[1]);
    return {
      apiKey: apiKey,
      organizationId: organizationId,
      productId: Number(options.productId || pathProductId) || null,
      origin: url ? url.origin : "",
    };
  }

  function organizationStorageKey(prefix, organizationId, accountKey) {
    var scope =
      Number.isInteger(organizationId) && organizationId > 0
        ? String(organizationId)
        : "pending";
    return prefix + scope + accountStorageSuffix(accountKey);
  }

  function deviceMarker(organizationId) {
    var key = organizationStorageKey("prophecy-device-", organizationId);
    var existing = null;
    try {
      existing = global.localStorage && global.localStorage.getItem(key);
    } catch (_) {
      existing = null;
    }
    if (existing) return existing;
    var created =
      "d-" +
      Math.random().toString(36).slice(2) +
      Math.random().toString(36).slice(2);
    try {
      if (global.localStorage) global.localStorage.setItem(key, created);
    } catch (_) {
      // Private browsing and blocked storage still get a trial; it simply
      // starts again on the next page.
    }
    return created;
  }

  function jsonPayload(value) {
    if (typeof value !== "string") return value;
    try {
      return JSON.parse(value);
    } catch (_) {
      return value;
    }
  }

  async function requestJson(url, init) {
    var response = await fetch(url, init);
    var body = await response.json().catch(function () {
      return {};
    });
    if (!response.ok) {
      throw sdkError(
        body.error || "Room AI request failed.",
        (typeof body.code === "string" && body.code) || "HTTP_" + response.status,
      );
    }
    return body;
  }

  function assertBrowserSession(
    value,
    productId,
    productReference,
    productSource,
    organizationId,
  ) {
    var session = value && value.session ? value.session : value;
    var rawSessionProductId = session && session.productId;
    var sessionProductId =
      rawSessionProductId === null ||
      rawSessionProductId === undefined ||
      rawSessionProductId === ""
        ? NaN
        : Number(rawSessionProductId);
    var sessionProductReference =
      session && typeof session.productReference === "string"
        ? session.productReference
        : Number.isInteger(sessionProductId)
          ? String(sessionProductId)
          : "";
    var sessionProductSource =
      session && typeof session.productSource === "string"
        ? session.productSource
        : productSource;
    var returnedOrganizationId = Number(session && session.organizationId);
    var sessionOrganizationId = returnedOrganizationId;
    if (
      !session ||
      typeof session.token !== "string" ||
      !session.token ||
      typeof session.sessionId !== "string" ||
      !session.sessionId ||
      sessionProductReference !== productReference ||
      sessionProductSource !== productSource ||
      !Number.isInteger(sessionOrganizationId) ||
      sessionOrganizationId <= 0 ||
      (Number.isInteger(organizationId) &&
        returnedOrganizationId > 0 &&
        returnedOrganizationId !== organizationId) ||
      (Number.isInteger(productId) && sessionProductId !== productId) ||
      !session.upload ||
      !Number.isFinite(Number(session.upload.maxBytes)) ||
      Number(session.upload.maxBytes) <= 0 ||
      !session.generation ||
      typeof session.generation.defaultResolution !== "string" ||
      !session.generation.defaultResolution ||
      !Number.isFinite(new Date(session.expiresAt).getTime()) ||
      new Date(session.expiresAt).getTime() <= Date.now()
    ) {
      throw sdkError(
        "The website returned an invalid Room AI session.",
        "INVALID_SESSION",
      );
    }
    return Object.assign({}, session, {
      productId: Number.isInteger(sessionProductId) ? sessionProductId : null,
      productReference: sessionProductReference,
      productSource: sessionProductSource,
      organizationId: sessionOrganizationId,
    });
  }

  function abortError(message) {
    var error = sdkError(message || "The operation was cancelled.", "ABORTED");
    error.name = "AbortError";
    return error;
  }

  function isAbortError(error) {
    return Boolean(
      error && (error.name === "AbortError" || error.code === "ABORTED"),
    );
  }

  function throwIfAborted(signal) {
    if (signal && signal.aborted) throw abortError();
  }

  function wait(ms, signal) {
    return new Promise(function (resolve, reject) {
      if (signal && signal.aborted) {
        reject(abortError());
        return;
      }
      var timeout = global.setTimeout(function () {
        if (signal) signal.removeEventListener("abort", handleAbort);
        resolve();
      }, ms);
      var handleAbort = function () {
        global.clearTimeout(timeout);
        reject(abortError());
      };
      if (signal) signal.addEventListener("abort", handleAbort, { once: true });
    });
  }

  function abortable(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(abortError());
    return new Promise(function (resolve, reject) {
      var handleAbort = function () {
        reject(abortError());
      };
      signal.addEventListener("abort", handleAbort, { once: true });
      Promise.resolve(promise).then(
        function (value) {
          signal.removeEventListener("abort", handleAbort);
          resolve(value);
        },
        function (error) {
          signal.removeEventListener("abort", handleAbort);
          reject(error);
        },
      );
    });
  }

  function normalizedAccountKey(value) {
    if (value === undefined || value === null || value === "") return null;
    return String(value).slice(0, 256);
  }

  function accountStorageSuffix(accountKey) {
    if (!accountKey) return "";
    var hash = 2166136261;
    for (var index = 0; index < accountKey.length; index += 1) {
      hash ^= accountKey.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return ":account:" + (hash >>> 0).toString(36);
  }

  async function fetchBoundedHistoryImage(url, signal, remainingBytes) {
    var parsed = new URL(url, global.location.href);
    if (parsed.protocol !== "https:" && parsed.protocol !== "http:") {
      throw sdkError("History image URLs must use HTTP or HTTPS.", "INVALID_HISTORY_URL");
    }
    var maxBytes = Math.min(HISTORY_MAX_IMAGE_BYTES, remainingBytes);
    if (maxBytes <= 0) {
      throw sdkError("The history image budget was exceeded.", "HISTORY_TOO_LARGE");
    }
    var response = await fetch(parsed.href, {
      credentials: "same-origin",
      signal: signal,
    });
    if (!response.ok) {
      throw sdkError("A saved room photo could not be loaded.", "HISTORY_IMAGE_FAILED");
    }
    var contentLength = Number(response.headers && response.headers.get("content-length"));
    if (Number.isFinite(contentLength) && contentLength > maxBytes) {
      throw sdkError("A saved room photo is too large.", "HISTORY_TOO_LARGE");
    }
    var contentType =
      (response.headers && response.headers.get("content-type")) || "";
    contentType = contentType.split(";")[0].trim().toLowerCase();
    if (contentType && !/^image\/(jpeg|png|webp)$/.test(contentType)) {
      throw sdkError("A saved room photo has an invalid type.", "INVALID_HISTORY_IMAGE");
    }
    if (!response.body || typeof response.body.getReader !== "function") {
      var fallbackBlob = await response.blob();
      if (fallbackBlob.size > maxBytes) {
        throw sdkError("A saved room photo is too large.", "HISTORY_TOO_LARGE");
      }
      return fallbackBlob;
    }
    var reader = response.body.getReader();
    var chunks = [];
    var received = 0;
    while (true) {
      throwIfAborted(signal);
      var next = await reader.read();
      if (next.done) break;
      received += next.value.byteLength;
      if (received > maxBytes) {
        await reader.cancel();
        throw sdkError("A saved room photo is too large.", "HISTORY_TOO_LARGE");
      }
      chunks.push(next.value);
    }
    return new Blob(chunks, { type: contentType || "application/octet-stream" });
  }

  function invokeHook(handler, value) {
    if (typeof handler !== "function") return;
    try {
      var result = handler(value);
      if (result && typeof result.catch === "function") {
        result.catch(function (error) {
          console.error("[room-ai-sdk] Integration hook failed:", error);
        });
      }
    } catch (error) {
      console.error("[room-ai-sdk] Integration hook failed:", error);
    }
  }

  function lockPageScroll() {
    if (!global.document || !global.document.body) return;
    if (pageLockCount === 0) {
      previousBodyOverflow = global.document.body.style.overflow;
      global.document.body.style.overflow = "hidden";
    }
    pageLockCount += 1;
  }

  function unlockPageScroll() {
    if (!global.document || !global.document.body || pageLockCount === 0) return;
    pageLockCount -= 1;
    if (pageLockCount === 0) {
      global.document.body.style.overflow = previousBodyOverflow;
      previousBodyOverflow = "";
    }
  }

  function normalizedProductId(value) {
    if (value === null || value === undefined || value === "") return null;
    var productId = Number(value);
    return Number.isInteger(productId) ? productId : null;
  }

  function validPreviewRecord(item) {
    return Boolean(
      item &&
        typeof item.url === "string" &&
        item.url.length > 0 &&
        (normalizedProductId(item.productId) !== null ||
          (typeof item.productReference === "string" &&
            item.productReference.length > 0)),
    );
  }

  function normalizedPreviewRecord(item) {
    return {
      id: typeof item.id === "string" ? item.id : undefined,
      jobId: typeof item.jobId === "string" ? item.jobId : undefined,
      url: item.url,
      productId: normalizedProductId(item.productId),
      productReference:
        typeof item.productReference === "string" && item.productReference
          ? item.productReference.slice(0, 200)
          : String(item.productId),
      productSource:
        item.productSource === "external-images"
          ? "external-images"
          : "ov25-configurator",
      selectionString:
        typeof item.selectionString === "string"
          ? item.selectionString.slice(0, 4000)
          : "",
      roomPhotoId:
        typeof item.roomPhotoId === "string" ? item.roomPhotoId : undefined,
      roomPhotoFingerprint:
        typeof item.roomPhotoFingerprint === "string"
          ? item.roomPhotoFingerprint
          : undefined,
      queryString:
        typeof item.queryString === "string"
          ? item.queryString.slice(0, 10000)
          : "",
      productUrl: sameSiteProductUrl(item.productUrl),
      pageUrl: sameSiteProductUrl(item.pageUrl),
      sku: typeof item.sku === "string" ? item.sku.slice(0, 500) : "",
      savedAt: Number.isFinite(Number(item.savedAt))
        ? Number(item.savedAt)
        : Date.now(),
    };
  }

  function mergePreviews(primary, secondary) {
    var seen = new Set();
    return primary.concat(secondary).filter(function (item) {
      if (!validPreviewRecord(item)) return false;
      var key = item.jobId || item.id || item.url;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function openPhotoDatabase() {
    return new Promise(function (resolve) {
      if (!global.indexedDB) {
        resolve(null);
        return;
      }
      var request;
      try {
        request = global.indexedDB.open(PHOTO_DB_NAME, 1);
      } catch (_) {
        resolve(null);
        return;
      }
      request.onupgradeneeded = function () {
        if (!request.result.objectStoreNames.contains(PHOTO_STORE_NAME)) {
          request.result.createObjectStore(PHOTO_STORE_NAME, {
            keyPath: "key",
          });
        }
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
      request.onerror = function () {
        resolve(null);
      };
      request.onblocked = function () {
        resolve(null);
      };
    });
  }

  async function withPhotoStore(mode, operation) {
    var database = await openPhotoDatabase();
    if (!database) return null;
    return new Promise(function (resolve) {
      var result = null;
      var settled = false;
      var finish = function (value) {
        if (settled) return;
        settled = true;
        try {
          database.close();
        } catch (_) {
          /* already closed */
        }
        resolve(value);
      };
      try {
        var transaction = database.transaction(PHOTO_STORE_NAME, mode);
        var request = operation(transaction.objectStore(PHOTO_STORE_NAME));
        if (request)
          request.onsuccess = function () {
            result = request.result;
          };
        transaction.oncomplete = function () {
          finish(result);
        };
        transaction.onerror = function () {
          finish(null);
        };
        transaction.onabort = function () {
          finish(null);
        };
      } catch (_) {
        finish(null);
      }
    });
  }

  function storedRoomPhotoIsValid(stored) {
    return Boolean(
      stored &&
        stored.blob instanceof Blob &&
        stored.width > 0 &&
        stored.height > 0 &&
        typeof stored.aspectRatio === "string" &&
        Number.isFinite(stored.savedAt) &&
        Date.now() - stored.savedAt <= PHOTO_MAX_AGE_MS,
    );
  }

  function roomPhotoFromStored(stored) {
    return {
      blob: stored.blob,
      width: stored.width,
      height: stored.height,
      aspectRatio: stored.aspectRatio,
      historyId:
        typeof stored.historyId === "string" ? stored.historyId : undefined,
      savedAt: stored.savedAt,
    };
  }

  async function readStoredRoomPhoto(key) {
    var stored = await withPhotoStore("readonly", function (store) {
      return store.get(key);
    });
    if (!stored) return null;
    if (!storedRoomPhotoIsValid(stored)) {
      withPhotoStore("readwrite", function (store) {
        return store.delete(key);
      });
      return null;
    }
    return roomPhotoFromStored(stored);
  }

  function saveStoredRoomPhoto(key, photo) {
    return withPhotoStore("readwrite", function (store) {
      return store.put({
        key: key,
        blob: photo.blob,
        width: photo.width,
        height: photo.height,
        aspectRatio: photo.aspectRatio,
        historyId: photo.historyId,
        savedAt: Date.now(),
      });
    });
  }

  async function readStoredRecentRoomPhotos(key) {
    var historyKey = "recent:" + key;
    var stored = await withPhotoStore("readonly", function (store) {
      return store.get(historyKey);
    });
    if (!stored || !Array.isArray(stored.photos)) return [];
    var photos = stored.photos
      .filter(storedRoomPhotoIsValid)
      .slice(0, RECENT_PHOTO_MAX_COUNT)
      .map(roomPhotoFromStored);
    if (photos.length !== stored.photos.length) {
      saveStoredRecentRoomPhotos(key, photos).catch(function () {});
    }
    return photos;
  }

  function saveStoredRecentRoomPhotos(key, photos) {
    return withPhotoStore("readwrite", function (store) {
      return store.put({
        key: "recent:" + key,
        photos: photos.slice(0, RECENT_PHOTO_MAX_COUNT).map(function (photo) {
          return {
            blob: photo.blob,
            width: photo.width,
            height: photo.height,
            aspectRatio: photo.aspectRatio,
            historyId: photo.historyId,
            savedAt: photo.savedAt,
          };
        }),
      });
    });
  }

  function deleteStoredRoomPhoto(key) {
    return withPhotoStore("readwrite", function (store) {
      return store.delete(key);
    });
  }

  function readStoredRoomPreviews(key) {
    try {
      var raw = global.localStorage && global.localStorage.getItem(key);
      var parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter(function (item) {
          return (
            item &&
            typeof item.url === "string" &&
            item.url.length > 0 &&
            (normalizedProductId(item.productId) !== null ||
              (typeof item.productReference === "string" &&
                item.productReference.length > 0)) &&
            Number.isFinite(item.savedAt) &&
            Date.now() - item.savedAt <= PREVIEW_MAX_AGE_MS
          );
        })
        .map(normalizedPreviewRecord)
        .slice(0, PREVIEW_MAX_COUNT);
    } catch (_) {
      return [];
    }
  }

  function saveStoredRoomPreview(key, preview) {
    try {
      if (!global.localStorage) return;
      var next = [preview]
        .concat(
          readStoredRoomPreviews(key).filter(function (item) {
            return item.url !== preview.url;
          }),
        )
        .slice(0, PREVIEW_MAX_COUNT);
      global.localStorage.setItem(key, JSON.stringify(next));
    } catch (_) {
      /* Preview history is an optional convenience. */
    }
  }

  function deleteStoredRoomPreviews(key) {
    try {
      if (global.localStorage) global.localStorage.removeItem(key);
    } catch (_) {
      /* Storage may be unavailable in private browsing. */
    }
  }

  function sameSiteProductUrl(value) {
    if (typeof value !== "string" || !value) return "";
    try {
      var url = new URL(value, global.location.href);
      return url.origin === global.location.origin ? url.href : "";
    } catch (_) {
      return "";
    }
  }

  function normalizeQueryString(value) {
    if (typeof value !== "string") return "";
    return value.replace(/^\?/, "").slice(0, 10000);
  }

  function productUrlForPreview(queryString) {
    try {
      var url = new URL(global.location.href);
      var query = normalizeQueryString(queryString);
      url.search = query ? "?" + query : "";
      return sameSiteProductUrl(url.href);
    } catch (_) {
      return "";
    }
  }

  function selectionStateFromPayload(payload) {
    var parsed = jsonPayload(payload);
    var selections = Array.isArray(parsed)
      ? parsed
      : parsed && Array.isArray(parsed.selectedSelections)
        ? parsed.selectedSelections
        : null;
    if (!selections) return null;
    try {
      return JSON.stringify(selections).slice(0, 4000);
    } catch (_) {
      return null;
    }
  }

  function nearestAspect(width, height) {
    var ratio = width / height;
    var best = ASPECT_RATIOS[0];
    var distance = Infinity;
    ASPECT_RATIOS.forEach(function (candidate) {
      var parts = candidate.split(":").map(Number);
      var nextDistance = Math.abs(Math.log(ratio / (parts[0] / parts[1])));
      if (nextDistance < distance) {
        best = candidate;
        distance = nextDistance;
      }
    });
    return best;
  }

  async function resizeRoomPhoto(file, maxEdge) {
    var bitmap = await createImageBitmap(file, {
      imageOrientation: "from-image",
    });
    var scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
    var width = Math.max(1, Math.round(bitmap.width * scale));
    var height = Math.max(1, Math.round(bitmap.height * scale));
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    var context = canvas.getContext("2d", { alpha: false });
    context.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();
    var blob = await new Promise(function (resolve) {
      canvas.toBlob(resolve, "image/jpeg", 0.9);
    });
    if (!blob)
      throw sdkError(
        "The room photo could not be prepared.",
        "IMAGE_PROCESSING_FAILED",
      );
    return {
      blob: blob,
      width: width,
      height: height,
      aspectRatio: nearestAspect(width, height),
    };
  }

  function closeImageBitmaps(bitmaps) {
    bitmaps.forEach(function (bitmap) {
      try {
        bitmap.close();
      } catch (_) {
        /* already closed */
      }
    });
  }

  async function imageBitmapToPngBlob(bitmap) {
    try {
      if (
        typeof global.OffscreenCanvas === "function" &&
        typeof global.OffscreenCanvas.prototype.convertToBlob === "function"
      ) {
        var offscreen = new global.OffscreenCanvas(bitmap.width, bitmap.height);
        var offscreenContext = offscreen.getContext("2d");
        if (!offscreenContext)
          throw sdkError(
            "A product view could not be prepared.",
            "PRODUCT_CAPTURE_FAILED",
          );
        offscreenContext.drawImage(bitmap, 0, 0);
        return await offscreen.convertToBlob({ type: "image/png" });
      }
      var canvas = document.createElement("canvas");
      canvas.width = bitmap.width;
      canvas.height = bitmap.height;
      var context = canvas.getContext("2d");
      if (!context)
        throw sdkError(
          "A product view could not be prepared.",
          "PRODUCT_CAPTURE_FAILED",
        );
      context.drawImage(bitmap, 0, 0);
      var blob = await new Promise(function (resolve) {
        canvas.toBlob(resolve, "image/png");
      });
      if (!blob)
        throw sdkError(
          "A product view could not be prepared.",
          "PRODUCT_CAPTURE_FAILED",
        );
      return blob;
    } finally {
      try {
        bitmap.close();
      } catch (_) {
        /* already closed */
      }
    }
  }

  function styles() {
    return `
      :host { --prophecy-accent: #111; --prophecy-ink: #111; --prophecy-muted: #666; --prophecy-paper: #fff; --prophecy-soft: #f5f5f5; --prophecy-line: #dedede; --prophecy-ease-out: cubic-bezier(.23,1,.32,1); --orbital-vision-gradient: linear-gradient(171.9957091344123deg, rgb(7, 5, 7) 31.292%, rgb(213, 32, 132) 168.45%); color-scheme: light; font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; }
      *, *::before, *::after { box-sizing: border-box; }
      button, input { font: inherit; }
      button, a { -webkit-tap-highlight-color: transparent; }
      [hidden] { display: none !important; }
      .backdrop { position: fixed; inset: 0; z-index: 2147483000; display: grid; place-items: center; padding: 24px; background: rgba(0,0,0,.64); opacity: 0; backdrop-filter: blur(8px); transition: opacity 160ms var(--prophecy-ease-out); }
      .backdrop.open { opacity: 1; }
      .dialog { position: relative; display: flex; width: min(100%, 680px); max-height: calc(100dvh - 48px); overflow: auto; flex-direction: column; border: 1px solid #d8d8d8; border-radius: 18px; background: var(--prophecy-paper); color: var(--prophecy-ink); box-shadow: 0 28px 80px rgba(0,0,0,.28); transform: translateY(8px) scale(.985); transform-origin: center; transition: transform 200ms var(--prophecy-ease-out); }
      .backdrop.open .dialog { transform: translateY(0) scale(1); }
      .header { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; padding: 28px 28px 0; }
      .header-copy { min-width: 0; }
      .title-block { min-width: 0; }
      .kicker { margin: 1px 0 5px; color: var(--prophecy-muted); font-size: 10px; font-weight: 760; letter-spacing: .14em; text-transform: uppercase; }
      h2 { margin: 0; font-family: inherit; font-size: clamp(24px, 4vw, 30px); font-weight: 650; line-height: 1.12; letter-spacing: -.035em; }
      .subtitle { margin: 8px 0 0; color: var(--prophecy-muted); font-size: 14px; line-height: 1.5; }
      .close { flex: 0 0 auto; display: grid; width: 40px; height: 40px; place-items: center; border: 1px solid var(--prophecy-line); border-radius: 50%; background: #fff; color: var(--prophecy-ink); cursor: pointer; transition: background-color 140ms ease, transform 120ms var(--prophecy-ease-out); }
      .close:active { transform: scale(.96); }
      .body { padding: 26px 28px 28px; }
      .copy { max-width: 560px; margin: 0 0 20px; color: var(--prophecy-muted); font-size: 14px; line-height: 1.58; }
      .photo-options { display: grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 12px; }
      .drop { display: grid; min-height: 178px; place-items: center; padding: 22px; border: 1px dashed #bdbdbd; border-radius: 14px; background: #fff; text-align: center; cursor: pointer; transition: border-color 160ms ease, background-color 160ms ease, transform 120ms var(--prophecy-ease-out), box-shadow 160ms ease; }
      .drop.drag { border-color: var(--prophecy-ink); background: var(--prophecy-soft); box-shadow: 0 10px 28px rgba(0,0,0,.08); }
      .drop:active { transform: scale(.98); }
      .drop-icon { display: grid; width: 54px; height: 54px; margin: 0 auto 13px; place-items: center; border: 1px solid var(--prophecy-line); border-radius: 12px; background: var(--prophecy-soft); color: var(--prophecy-ink); }
      .drop strong { display: block; margin-bottom: 4px; color: var(--prophecy-ink); font-size: 15px; font-weight: 720; }
      .drop span { color: var(--prophecy-muted); font-size: 12px; }
      .camera-choice { display: none; align-items: center; gap: 14px; min-height: 76px; padding: 14px 16px; border: 1px solid var(--prophecy-accent); border-radius: 15px; background: var(--prophecy-accent); color: #fff; cursor: pointer; transition: filter 160ms ease, transform 120ms var(--prophecy-ease-out); }
      .camera-choice:active { transform: scale(.985); }
      .camera-icon { display: grid; flex: 0 0 auto; place-items: center; width: 44px; height: 44px; border-radius: 50%; background: rgba(255,255,255,.14); }
      .camera-copy { display: grid; gap: 3px; }
      .camera-copy strong { font-size: 16px; }
      .camera-copy span { color: rgba(255,255,255,.76); font-size: 12px; }
      .phone-choice { display: grid; width: 100%; min-height: 178px; place-items: center; padding: 22px; border: 1px solid var(--prophecy-line); border-radius: 14px; background: var(--prophecy-soft); color: var(--prophecy-ink); text-align: center; cursor: pointer; transition: border-color 160ms ease, background-color 160ms ease, transform 120ms var(--prophecy-ease-out), box-shadow 160ms ease; }
      .phone-choice:active { transform: scale(.98); }
      .phone-icon { display: grid; width: 54px; height: 54px; margin: 0 auto 13px; place-items: center; border: 1px solid var(--prophecy-line); border-radius: 12px; background: #fff; color: var(--prophecy-ink); }
      .phone-copy { display: grid; gap: 3px; }
      .phone-copy strong { font-size: 15px; font-weight: 720; }
      .phone-copy span { color: var(--prophecy-muted); font-size: 12px; }
      .result-slide.pending { display: flex; align-items: center; justify-content: center; background: var(--prophecy-soft); border: 1px solid var(--prophecy-line); border-radius: 18px; aspect-ratio: 4 / 3; }
      .result-thumbnail.pending { display: flex; align-items: center; justify-content: center; background: #f4f4f5; }
      .thumbnail-spinner { width: 14px; height: 14px; border: 2px solid var(--prophecy-line); border-top-color: #111; border-radius: 50%; animation: prophecy-spin 700ms linear infinite; }
      @keyframes prophecy-spin { to { transform: rotate(360deg); } }
      @media (prefers-reduced-motion: reduce) { .thumbnail-spinner { animation-duration: 2s; } }
      .result-slide.pending .generating-title { font-size: 15px; }
      .result-slide.pending .generating-copy { font-size: 12px; }
      .library-section { margin-bottom: 22px; }
      .library-section:last-child { margin-bottom: 0; }
      .library-head { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin: 0 0 11px; }
      .library-head h3 { margin: 0; color: #444; font-size: 12px; font-weight: 720; letter-spacing: .02em; }
      .add-room { display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; padding: 0; border: 1px solid var(--prophecy-line); border-radius: 8px; background: #fff; color: #111; cursor: pointer; transition: background-color 150ms cubic-bezier(.23,1,.32,1), transform 120ms cubic-bezier(.23,1,.32,1); }
      .add-room:active { transform: scale(.94); }
      @media (hover: hover) and (pointer: fine) { .add-room:hover { background: #f4f4f5; } }
      .library-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(88px, 1fr)); gap: 8px; }
      .library-item { padding: 0; border: 1px solid var(--prophecy-line); border-radius: 10px; overflow: hidden; background: #f4f4f5; cursor: pointer; aspect-ratio: 4 / 3; transition: transform 120ms cubic-bezier(.23,1,.32,1); }
      .library-item:active { transform: scale(.97); }
      .library-item img { display: block; width: 100%; height: 100%; object-fit: cover; }
      .library-empty { margin: 0; color: #777; font-size: 12px; }
      .recent-photos { margin-top: 20px; padding-top: 18px; border-top: 1px solid var(--prophecy-line); }
      .recent-photos h3 { margin: 0 0 11px; color: #444; font-size: 12px; font-weight: 720; letter-spacing: .02em; }
      .recent-photo-list { display: flex; gap: 9px; overflow-x: auto; padding: 1px 1px 5px; scrollbar-width: thin; -webkit-overflow-scrolling: touch; }
      .recent-photo { position: relative; flex: 0 0 86px; width: 86px; overflow: hidden; aspect-ratio: 4/3; padding: 0; border: 2px solid transparent; border-radius: 12px; background: var(--prophecy-soft); cursor: pointer; transition: border-color 150ms ease, transform 120ms var(--prophecy-ease-out); }
      .recent-photo img { display: block; width: 100%; height: 100%; object-fit: cover; }
      .recent-photo:active { transform: scale(.97); }
      .room-input, .camera-input { position: absolute; width: 1px; height: 1px; overflow: hidden; opacity: 0; pointer-events: none; }
      .privacy { display: flex; gap: 9px; align-items: flex-start; margin: 15px 2px 0; color: #767676; font-size: 11px; line-height: 1.5; }
      .privacy svg { flex: 0 0 auto; margin-top: 1px; }
      .preview-wrap, .result-wrap { position: relative; overflow: hidden; border: 1px solid var(--prophecy-line); border-radius: 18px; background: var(--prophecy-soft); line-height: 0; }
      .preview, .result { display: block; width: 100%; height: auto; max-height: 58vh; object-fit: contain; }
      .result-carousel { display: flex; align-items: flex-start; overflow-x: auto; border-radius: 18px; scroll-behavior: smooth; scroll-snap-type: x mandatory; scrollbar-width: none; -webkit-overflow-scrolling: touch; }
      .result-carousel::-webkit-scrollbar { display: none; }
      .result-slide { flex: 0 0 100%; min-width: 0; scroll-snap-align: start; scroll-snap-stop: always; }
      .result-disclaimer { margin: 10px 2px 0; color: #777; font-size: 10px; line-height: 1.5; }
      .result-thumbnails { display: flex; gap: 8px; overflow-x: auto; margin-top: 12px; padding: 2px 2px 5px; scrollbar-width: thin; -webkit-overflow-scrolling: touch; }
      .result-thumbnail { flex: 0 0 76px; width: 76px; overflow: hidden; aspect-ratio: 4/3; padding: 0; border: 2px solid transparent; border-radius: 11px; background: var(--prophecy-soft); cursor: pointer; transition: border-color 150ms ease, transform 120ms var(--prophecy-ease-out); }
      .result-thumbnail img { display: block; width: 100%; height: 100%; object-fit: cover; }
      .result-thumbnail[aria-current="true"] { border-color: var(--prophecy-accent); }
      .result-thumbnail:active { transform: scale(.97); }
      .result-back { display: inline-flex; min-height: 36px; align-items: center; gap: 6px; margin: -8px 0 9px; padding: 0 3px; border: 0; background: transparent; color: var(--prophecy-muted); font-size: 12px; font-weight: 680; cursor: pointer; transition: color 150ms ease, transform 120ms var(--prophecy-ease-out); }
      .result-back:active { transform: scale(.98); }
      .preview-action { position: absolute; right: 12px; bottom: 12px; min-height: 38px; padding: 0 13px; border: 1px solid rgba(0,0,0,.1); border-radius: 10px; background: rgba(255,255,255,.94); color: var(--prophecy-ink); font-size: 12px; font-weight: 680; box-shadow: 0 4px 16px rgba(0,0,0,.13); cursor: pointer; transition: transform 120ms var(--prophecy-ease-out), background-color 150ms ease; }
      .preview-action:active { transform: scale(.97); }
      .actions { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 10px; margin-top: 18px; }
      .button { display: inline-flex; min-height: 48px; align-items: center; justify-content: center; padding: 0 19px; border: 1px solid transparent; border-radius: 12px; font-size: 13px; font-weight: 720; text-decoration: none; cursor: pointer; transition: background-color 150ms ease, border-color 150ms ease, filter 150ms ease, transform 120ms var(--prophecy-ease-out), opacity 150ms ease; }
      .button:active { transform: scale(.97); }
      .button:disabled { cursor: wait; opacity: .56; }
      .primary { background: var(--prophecy-accent); color: #fff; }
      .secondary { border-color: var(--prophecy-line); background: #fff; color: var(--prophecy-ink); }
      .error { margin: 20px 28px 0; padding: 12px 14px; border: 1px solid #c8c8c8; border-radius: 10px; background: var(--prophecy-soft); color: var(--prophecy-ink); font-size: 12px; line-height: 1.45; }
      .generating { display: grid; min-height: 370px; place-items: center; padding: 42px; text-align: center; }
      .generation-clock { position: relative; display: grid; width: 82px; height: 82px; margin: 0 auto 22px; place-items: center; color: var(--prophecy-ink); }
      .generation-clock svg { position: absolute; inset: 0; width: 100%; height: 100%; transform: rotate(-90deg); }
      .generation-track, .generation-progress { fill: none; stroke-width: 4; }
      .generation-track { stroke: #dedede; }
      .generation-progress { stroke: var(--prophecy-accent); stroke-dasharray: 100; stroke-dashoffset: 100; stroke-linecap: round; transition: stroke-dashoffset 80ms linear; }
      .generation-time { position: relative; font-size: 13px; font-variant-numeric: tabular-nums; font-weight: 740; letter-spacing: -.02em; }
      .generating h3 { margin: 0 0 8px; font-family: inherit; font-size: 21px; font-weight: 650; letter-spacing: -.025em; }
      .generating p { margin: 0; color: var(--prophecy-muted); font-size: 13px; line-height: 1.55; }
      .result-actions { margin-top: 14px; }
      .phone-view { text-align: center; }
      .phone-view .copy { max-width: 430px; margin-inline: auto; }
      .qr-frame { display: grid; width: 280px; height: 280px; margin: 0 auto; place-items: center; border: 1px solid var(--prophecy-line); border-radius: 18px; background: #fff; box-shadow: 0 10px 30px rgba(0,0,0,.07); }
      .qr-frame img { display: block; width: 256px; height: 256px; border-radius: 8px; }
      .qr-placeholder { width: 34px; height: 34px; border: 3px solid #dedede; border-top-color: var(--prophecy-accent); border-radius: 50%; animation: spin 720ms linear infinite; }
      .phone-link { display: block; max-width: 430px; margin: 15px auto 0; overflow: hidden; color: var(--prophecy-muted); font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
      .phone-status { display: flex; min-height: 24px; margin-top: 16px; align-items: center; justify-content: center; gap: 8px; color: #505050; font-size: 12px; font-weight: 650; }
      .status-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--prophecy-ink); }
      .phone-actions { display: flex; justify-content: center; gap: 10px; margin-top: 18px; }
      .powered { display: flex; min-height: 52px; align-items: center; justify-content: center; padding: 13px 24px; border-top: 1px solid var(--prophecy-line); font-size: 10px; letter-spacing: .025em; }
      .powered-link { display: inline-flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 5px; color: var(--prophecy-muted); text-decoration: none; transition: opacity 140ms ease, transform 120ms var(--prophecy-ease-out); }
      .powered-link strong { color: var(--prophecy-ink); font-weight: 760; }
      .powered-link:active { transform: scale(.97); }
      .orbital-brand { display: inline-flex; align-items: center; gap: 5px; font-weight: 720; letter-spacing: -.01em; }
      .orbital-mark { display: block; width: 23px; height: 12px; background: var(--orbital-vision-gradient); -webkit-mask: ${ORBITAL_VISION_LOGO_MASK} center / contain no-repeat; mask: ${ORBITAL_VISION_LOGO_MASK} center / contain no-repeat; }
      .orbital-name { background: var(--orbital-vision-gradient); color: transparent; -webkit-background-clip: text; background-clip: text; }
      :focus-visible { outline: 3px solid color-mix(in srgb, var(--prophecy-accent) 30%, transparent); outline-offset: 2px; }
      @keyframes spin { to { transform: rotate(360deg); } }
      @media (hover: hover) and (pointer: fine) {
        .close:hover { background: #fff; }
        .drop:hover, .phone-choice:hover { border-color: color-mix(in srgb, var(--prophecy-accent) 55%, transparent); background: #fff; box-shadow: 0 10px 28px rgba(0,0,0,.07); }
        .recent-photo:hover, .result-thumbnail:hover { border-color: var(--prophecy-accent); }
        .result-back:hover { color: var(--prophecy-ink); }
        .preview-action:hover, .secondary:hover { background: var(--prophecy-soft); }
        .primary:hover { filter: brightness(.92); }
        .powered-link:hover { opacity: .68; }
      }
      @media (max-width: 640px) {
        .backdrop { padding: 0; place-items: end stretch; }
        .dialog { width: 100%; max-height: 92dvh; min-height: 0; border: 0; border-radius: 20px 20px 0 0; box-shadow: 0 -8px 40px rgba(0,0,0,.24); transform: translateY(100%); }
        .backdrop.open .dialog { transform: translateY(0); }
        .dialog::before { content: ""; position: sticky; top: 0; z-index: 3; display: block; width: 40px; height: 4px; margin: 8px auto 0; border-radius: 999px; background: #d8d8d8; }
        .header { padding: 12px 18px 0; }
        .body { padding: 20px 18px; }
        .error { margin: 16px 18px 0; }
        .photo-options { grid-template-columns: 1fr; }
        .camera-choice { display: flex; text-align: left; }
        .phone-choice { display: none; }
        .drop { display: flex; min-height: 76px; place-items: initial; gap: 14px; padding: 14px 16px; border-style: solid; text-align: left; }
        .drop-icon { flex: 0 0 auto; width: 44px; height: 44px; margin: 0; }
        .drop > span { display: grid; align-content: center; gap: 3px; }
        .drop strong { margin: 0; font-size: 16px; }
        .actions { flex-direction: column-reverse; }
        .button { width: 100%; }
        /* On a phone the buttons close the sheet: picture, then the small
           print, then the strip to compare, then what to do about it. */
        .result-view { display: flex; flex-direction: column; }
        .result-view .result-back { order: 0; }
        .result-view .result-carousel { order: 1; }
        .result-view .result-disclaimer { order: 2; }
        .result-view .result-thumbnails { order: 3; }
        .result-view .result-actions { order: 4; margin-top: 18px; }
        .qr-frame { width: min(280px, 84vw); height: min(280px, 84vw); }
        .qr-frame img { width: calc(min(280px, 84vw) - 24px); height: calc(min(280px, 84vw) - 24px); }
        .phone-actions { flex-direction: column-reverse; }
        .powered { margin-top: auto; }
      }
      @media (hover: none) and (pointer: coarse) {
        .camera-choice { display: flex; text-align: left; }
        .phone-choice { display: none; }
      }
      @media (prefers-reduced-motion: reduce) {
        .dialog { transform: none; }
        .backdrop, .dialog, .button, .close, .drop, .phone-choice, .recent-photo, .result-thumbnail, .result-back, .preview-action, .generation-progress, .powered-link { transition-duration: 0ms; }
        .qr-placeholder { animation: none; border-color: #dedede; border-top-color: var(--prophecy-accent); }
        .result-carousel { scroll-behavior: auto; }
      }
      @media (forced-colors: active) {
        .orbital-mark { background: LinkText; }
        .orbital-name { background: none; color: LinkText; }
      }
    `;
  }

  function createUi(instance) {
    var host = document.createElement("div");
    host.dataset.orbitalRoomAi = instance.id;
    host.dataset.prophecy = instance.id;
    document.body.appendChild(host);
    var root = host.attachShadow({ mode: "open" });
    root.innerHTML = `
      <style></style>
      <div class="backdrop" hidden>
        <section class="dialog" role="dialog" aria-modal="true" aria-labelledby="room-ai-title">
          <header class="header">
            <div class="header-copy">
              <div class="title-block">
                <p class="kicker">Room preview</p>
                <h2 id="room-ai-title">Picture it in your space</h2>
                <p class="subtitle">Bring the product into a photo of your room in moments.</p>
              </div>
            </div>
            <button class="close" type="button" aria-label="Close room preview">
              <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="m4 4 10 10M14 4 4 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
            </button>
          </header>
          <p class="error" role="alert" hidden></p>
          <div class="body upload-view">
            <div class="photo-options">
              <button class="phone-choice" type="button">
                <span class="phone-icon"><svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><rect x="6.7" y="2.7" width="10.6" height="18.6" rx="2.2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M10 5.6h4M11.2 18.4h1.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
                <span class="phone-copy"><strong>Phone</strong><span>Take a photo</span></span>
              </button>
              <label class="camera-choice" role="button" tabindex="0">
                <input class="camera-input" type="file" accept="image/jpeg,image/png,image/webp" capture="environment" tabindex="-1" />
                <span class="camera-icon"><svg width="23" height="23" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7.5h3l1.4-2h7.2l1.4 2h3v11H4z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.3" fill="none" stroke="currentColor" stroke-width="1.8"/></svg></span>
                <span class="camera-copy"><strong>Take a photo</strong><span>Use your phone’s rear camera</span></span>
              </label>
              <label class="drop" role="button" tabindex="0">
                <input class="room-input" type="file" accept="image/jpeg,image/png,image/webp" tabindex="-1" />
                <span>
                  <span class="drop-icon"><svg width="23" height="23" viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="4.5" width="17" height="12.5" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8 20h8M12 17v3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
                  <strong>Upload a room photo</strong>
                  <span>JPEG, PNG or WebP</span>
                </span>
              </label>
            </div>
            <section class="recent-photos" aria-labelledby="recent-room-photos-title" hidden>
              <h3 id="recent-room-photos-title">Your rooms</h3>
              <div class="recent-photo-list"></div>
            </section>
          </div>
          <div class="body library-view" hidden>
            <section class="library-section library-designs-section" hidden>
              <div class="library-head"><h3>Your designs</h3></div>
              <div class="library-grid library-designs"></div>
            </section>
            <section class="library-section">
              <div class="library-head">
                <h3>Your rooms</h3>
                <button class="add-room" type="button" aria-label="Add a room photo">
                  <svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><path d="M8 3.2v9.6M3.2 8h9.6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>
                </button>
              </div>
              <div class="library-grid library-rooms"></div>
            </section>
          </div>
          <div class="body phone-view" hidden>
            <p class="copy">Scan with your phone, choose a room photo there, and it will appear here securely.</p>
            <div class="qr-frame"><div class="qr-placeholder" aria-label="Creating secure link"></div><img class="phone-qr" alt="QR code to open the room photo uploader on your phone" hidden /></div>
            <a class="phone-link" target="_blank" rel="noopener noreferrer" hidden></a>
            <div class="phone-status" role="status"><span class="status-dot"></span><span>Creating a secure link…</span></div>
            <div class="phone-actions"><button class="button secondary phone-back" type="button">Choose another way</button><button class="button secondary copy-link" type="button" disabled>Copy link</button></div>
            <p class="privacy"><svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><path d="M4.5 7V5a3.5 3.5 0 0 1 7 0v2M3 7.5h10v7H3z" fill="none" stroke="currentColor" stroke-width="1.3"/></svg><span>This one-time link expires after 10 minutes.</span></p>
          </div>
          <div class="body preview-view" hidden>
            <button class="result-back another" type="button"><svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><path d="m9.5 3-5 5 5 5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Try another room</span></button>
            <div class="preview-wrap"><img class="preview" alt="Your selected room photo" /><button class="preview-action" type="button">Choose another</button></div>
            <div class="actions"><button class="button secondary cancel" type="button">Not now</button><button class="button primary generate" type="button">See it in my room</button></div>
          </div>
          <div class="generating generating-view" role="status" aria-live="polite" hidden>${generatingMarkup("Bringing it into your room", "This usually takes 20 to 30 seconds.")}</div>
          <div class="body result-view" hidden>
            <button class="result-back another" type="button"><svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><path d="m9.5 3-5 5 5 5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Try another room</span></button>
            <div class="result-carousel" aria-label="Your room previews"></div>
            <div class="actions result-actions"><button class="button secondary continue-shopping" type="button">Continue shopping</button><button class="button primary order-product" type="button" aria-label="Order selected product" hidden>Order this product</button></div>
            <div class="result-thumbnails" aria-label="Choose a product preview" hidden></div>
            <p class="result-disclaimer">AI-generated preview. Colours, scale and details may vary. Measure your space, check the product dimensions and order swatches before you buy.</p>
          </div>
          <footer class="powered"><a class="powered-link" href="https://orbital.vision/" target="_blank" rel="noopener noreferrer"><span>Powered by <strong>OV25</strong> from </span><span class="orbital-brand"><span class="orbital-mark" aria-hidden="true"></span><span class="orbital-name">Orbital Vision</span></span></a></footer>
        </section>
      </div>`;
    root.querySelector("style").textContent = styles();
    return { host: host, root: root };
  }

  function RoomAiInstance(options) {
    this.options = options || {};
    this.id = "prophecy-" + ++instances;
    this.development =
      typeof this.options.development === "boolean"
        ? this.options.development
        : isDevelopmentHost();
    this.productImageSources = normalizeProductImageSources(
      this.options.productImages,
    );
    this.productVersion = 0;
    this.iframe = resolveConfigurator(
      this.options.configurator,
      this.development,
    );
    this.endpoint = String(
      this.options.endpoint || defaultEndpoint(this.iframe),
    ).replace(/\/$/, "");
    if (!this.iframe && this.productImageSources.length === 0) {
      throw sdkError(
        "Prophecy needs a configurator.orbital.vision iframe or productImages.",
        "PRODUCT_SOURCE_REQUIRED",
      );
    }
    this.config = parseConfiguratorUrl(this.iframe, this.options);
    var hasPartnerSession = Boolean(
      this.options.sessionEndpoint ||
        typeof this.options.sessionProvider === "function",
    );
    if (
      !Number.isInteger(this.config.organizationId) &&
      !hasPartnerSession &&
      this.productImageSources.length === 0
    ) {
      throw sdkError(
        "Prophecy needs an OV25 configurator or partner session endpoint to identify the organization.",
        "INVALID_CONFIG",
      );
    }
    this.productId = this.config.productId;
    this.productSource =
      this.productImageSources.length > 0
        ? "external-images"
        : "ov25-configurator";
    this.productReference = normalizeProductReference(
      this.options.productReference,
      this.productId,
    );
    if (!this.productReference && this.productSource === "external-images") {
      throw sdkError(
        "productReference is required with productImages.",
        "INVALID_PRODUCT_REFERENCE",
      );
    }
    if (
      this.productSource === "external-images" &&
      !this.options.sessionEndpoint &&
      typeof this.options.sessionProvider !== "function"
    ) {
      throw sdkError(
        "External product images require a same-origin sessionEndpoint or sessionProvider.",
        "PARTNER_SESSION_REQUIRED",
      );
    }
    if (
      this.productSource === "ov25-configurator" &&
      !this.config.apiKey
    ) {
      throw sdkError(
        "Prophecy could not infer the OV25 public key from the configurator URL.",
        "INVALID_CONFIG",
      );
    }
    this.selectionString = "";
    this.selectionsReceived = false;
    this.configuratorSpoke = false;
    this.watchConfiguratorLoad();
    this.currentProductQuery = normalizeQueryString(global.location.search);
    // The configurator's own SKU for what is on screen, once it has said.
    this.sku = "";
    this.explicitProductUrl = sameSiteProductUrl(this.options.productUrl);
    this.session = null;
    this.sessionPromise = null;
    this.availability = "unchecked";
    this.availabilityError = null;
    this.availabilityPromise = null;
    this.availabilityFetch = null;
    this.overlay = null;
    this.justFinished = false;
    this.finishedTimer = null;
    this.freshDesign = false;
    this.access = "open";
    this.freeGenerations = null;
    this.pendingProductViews = new Map();
    // Message listeners share the transferred objects. Only the requesting
    // instance may consume or close them, including after its request times out.
    // Include randomness because separate copies of the SDK restart instance ids.
    this.productViewRequestPrefix =
      "room-ai-" + this.id + "-" + Math.random().toString(36).slice(2) + "-";
    this.productViewBlobs = null;
    this.productViewKey = null;
    this.productViewPromise = null;
    this.productViewPromiseKey = null;
    this.roomPhoto = null;
    this.openState = false;
    this.openPromise = null;
    this.closeTimer = null;
    this.accountKey = normalizedAccountKey(this.options.accountKey);
    this.accountEpoch = 0;
    this.historyEpoch = 0;
    this.historyQueue = Promise.resolve();
    this.historyController = new global.AbortController();
    this.historyLoadController = null;
    this.generationController = null;
    var hasAccountIntegration = Boolean(
      this.options.history ||
        this.options.sessionEndpoint ||
        this.options.sessionProvider,
    );
    this.localHistoryEnabled =
      this.options.localHistory === true ||
      (!hasAccountIntegration && this.options.localHistory !== false);
    this.roomPhotoStorageKey = organizationStorageKey(
      "organization:",
      this.config.organizationId,
      this.accountKey,
    );
    this.previewHistoryStorageKey = organizationStorageKey(
      "orbital-room-ai-previews:organization:",
      this.config.organizationId,
      this.accountKey,
    );
    this.recentRoomPhotos = [];
    this.recentPhotoUrls = [];
    this.libraryRoomUrls = [];
    this.accountPreviews = [];
    this.listeners = new Map();
    this.photoRestorePromise =
      this.localHistoryEnabled && Number.isInteger(this.config.organizationId)
      ? this.restoreRoomPhoto()
      : Promise.resolve();
    this.recentPhotosRestorePromise =
      this.localHistoryEnabled && Number.isInteger(this.config.organizationId)
      ? this.restoreRecentRoomPhotos()
      : Promise.resolve();
    this.accountHistoryLoaded = false;
    this.accountHistoryRestorePromise = Promise.resolve();
    this.previewUrl = null;
    this.carouselIndex = 0;
    this.carouselItems = [];
    this.pendingPreview = false;
    this.maxUploadBytes = 12 * 1024 * 1024;
    this.phoneHandoff = null;
    this.phonePollTimer = null;
    this.currentView = "upload";
    // Every generation still running, keyed by the configuration it is for, so
    // changing the fabric mid-generation is a new thing to make rather than a
    // wait. The account decides how many at once; three until it says.
    this.pending = new Map();
    this.pendingSequence = 0;
    // Whether the frame on screen is still the old fabric. The configurator
    // says so itself; until it has said it once, nothing here waits on it.
    this.sceneBusy = false;
    this.sceneSpeaksLoading = false;
    this.sceneSettleTimer = null;
    this.maxConcurrent = 3;
    this.generationClockId = null;
    this.lastFocus = null;
    this.destroyed = false;
    this.ui = null;
    this.launcher = null;
    this.handleMessage = this.handleMessage.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    if (this.iframe) global.addEventListener("message", this.handleMessage);
    if (this.options.button) this.attach(this.options.button);
    if (this.productSource === "ov25-configurator") this.requestProductId();
    Promise.resolve().then(
      function () {
        if (!this.destroyed) this.emit("ready", this.getState());
      }.bind(this),
    );
  }

  RoomAiInstance.prototype.emit = function (type, detail) {
    var event = {
      type: type,
      timestamp: new Date().toISOString(),
      instanceId: this.id,
      organizationId: this.config.organizationId,
      productId:
        detail && Number.isInteger(Number(detail.productId))
          ? Number(detail.productId)
          : this.productId,
      productReference:
        detail && typeof detail.productReference === "string"
          ? detail.productReference
          : this.productReference,
      productSource: this.productSource,
      detail: detail || {},
    };
    var handlers = []
      .concat(Array.from(this.listeners.get(type) || []))
      .concat(Array.from(this.listeners.get("*") || []));
    handlers.forEach(function (handler) {
      invokeHook(handler, event);
    });
    invokeHook(this.options.onEvent, event);

    var callbackByEvent = {
      ready: "onReady",
      "availability-change": "onAvailabilityChange",
      open: "onOpen",
      close: "onClose",
      "view-change": "onViewChange",
      "product-change": "onProductChange",
      "account-change": "onAccountChange",
      "selection-change": "onSelectionChange",
      "photo-selected": "onPhotoSelected",
      "photo-cleared": "onPhotoCleared",
      "sign-in-required": "onSignInRequired",
      order: "onOrder",
      "phone-handoff-start": "onPhoneHandoffStart",
      "phone-photo-received": "onPhonePhotoReceived",
      "generation-start": "onGenerationStart",
      "generation-progress": "onGenerationProgress",
      "generation-complete": "onResult",
      "generation-error": "onGenerationError",
      error: "onError",
      "history-load": "onHistoryLoad",
      "history-save": "onHistorySave",
      "history-error": "onHistoryError",
      destroyed: "onDestroy",
    };
    var callback = this.options[callbackByEvent[type]];
    var callbackValue =
      type === "generation-error" ||
      type === "history-error" ||
      type === "error"
        ? event.detail.error
        : event.detail;
    invokeHook(callback, callbackValue);

    if (this.launcher && this.launcher.element && global.CustomEvent) {
      ["prophecy", "orbital-room-ai"].forEach(function (eventName) {
        this.launcher.element.dispatchEvent(
          new global.CustomEvent(eventName, {
          detail: event,
          bubbles: true,
          composed: true,
          }),
        );
      }, this);
    }
    return event;
  };

  RoomAiInstance.prototype.on = function (type, handler) {
    if (typeof type !== "string" || typeof handler !== "function") {
      throw sdkError("on(event, handler) requires an event name and function.");
    }
    var handlers = this.listeners.get(type) || new Set();
    handlers.add(handler);
    this.listeners.set(type, handlers);
    return function () {
      handlers.delete(handler);
    };
  };

  RoomAiInstance.prototype.off = function (type, handler) {
    var handlers = this.listeners.get(type);
    if (handlers) handlers.delete(handler);
    return this;
  };

  RoomAiInstance.prototype.getState = function () {
    return {
      isOpen: this.isOpen(),
      availability: this.availability,
      access: this.access,
      freeGenerations: this.freeGenerations,
      view: this.currentView,
      productId: this.productId,
      productReference: this.productReference,
      productSource: this.productSource,
      organizationId: this.config.organizationId,
      sku: this.sku,
      hasRoomPhoto: Boolean(this.roomPhoto),
      generating: this.isGenerating(),
      accountScoped: Boolean(this.session && this.session.accountScoped),
      accountContext: Boolean(this.accountKey),
    };
  };

  RoomAiInstance.prototype.adoptSessionOrganization = function (organizationId) {
    var next = Number(organizationId);
    if (!Number.isInteger(next) || next <= 0) {
      throw sdkError(
        "The website returned an invalid organization in its Prophecy session.",
        "INVALID_SESSION",
      );
    }
    if (
      Number.isInteger(this.config.organizationId) &&
      this.config.organizationId !== next
    ) {
      throw sdkError(
        "The Prophecy session does not belong to this configurator.",
        "INVALID_SESSION",
      );
    }
    if (this.config.organizationId === next) return;
    this.config.organizationId = next;
    this.roomPhotoStorageKey = organizationStorageKey(
      "organization:",
      next,
      this.accountKey,
    );
    this.previewHistoryStorageKey = organizationStorageKey(
      "orbital-room-ai-previews:organization:",
      next,
      this.accountKey,
    );
    if (this.localHistoryEnabled) {
      this.photoRestorePromise = this.restoreRoomPhoto();
      this.recentPhotosRestorePromise = this.restoreRecentRoomPhotos();
    }
  };

  /**
   * Resolves once the configurator has named its current product.
   *
   * A single-product embed has the id in its URL, but an embed that ships
   * several products does not, so the id arrives over postMessage some time
   * after the iframe loads. Availability deliberately does not depend on the
   * product, so a shopper can reach the launcher before that answer has
   * arrived; without this the dialog would open and immediately fail.
   */
  RoomAiInstance.prototype.whenProductReady = function (timeoutMs) {
    if (this.productSource !== "ov25-configurator") return Promise.resolve();
    if (Number.isInteger(this.productId)) return Promise.resolve();
    var instance = this;
    this.requestProductId();
    return new Promise(function (resolve) {
      var settled = false;
      var finish = function () {
        if (settled) return;
        settled = true;
        global.clearInterval(poll);
        global.clearTimeout(timer);
        resolve();
      };
      var poll = global.setInterval(function () {
        if (Number.isInteger(instance.productId) || instance.destroyed) finish();
      }, 50);
      var timer = global.setTimeout(finish, timeoutMs || 3000);
    });
  };

  RoomAiInstance.prototype.requestProductId = function () {
    if (this.iframe && this.iframe.contentWindow) {
      this.iframe.contentWindow.postMessage(
        { type: "REQUEST_CURRENT_PRODUCT_ID", payload: "" },
        this.config.origin,
      );
    }
  };

  RoomAiInstance.prototype.handleMessage = function (event) {
    if (
      !this.iframe ||
      this.productSource !== "ov25-configurator" ||
      event.source !== this.iframe.contentWindow ||
      event.origin !== this.config.origin ||
      !event.data
    )
      return;
    var data = event.data;
    // Anything at all from the iframe means it has booted and its bridge is
    // live, which is what the launcher and the widget wait for.
    if (!this.configuratorSpoke) {
      this.configuratorSpoke = true;
      this.syncLauncherAvailability();
      this.renderOverlay();
    }
    if (data.type === "CURRENT_PRODUCT_ID") {
      var nextProduct = Number(jsonPayload(data.payload));
      if (Number.isInteger(nextProduct) && nextProduct !== this.productId) {
        var previousProduct = this.productId;
        var previousReference = this.productReference;
        this.productId = nextProduct;
        this.productReference = String(nextProduct);
        this.session = null;
        this.sessionPromise = null;
        this.availability = "unchecked";
        this.availabilityError = null;
        this.invalidateProductViews();
        this.prepareRoomPhotoForReuse();
        this.emit("product-change", {
          previousProductId: previousProduct,
          previousProductReference: previousReference,
          productId: nextProduct,
          productReference: this.productReference,
          source: "configurator",
        });
        if (this.launcher && !this.development) this.checkAvailability();
        this.syncLauncherAvailability();
        this.renderOverlay();
        if (this.isOpen()) this.prepareProductViews().catch(function () {});
      }
    } else if (data.type === "IS_LOADING") {
      // True while the painted frame may not be the current product. The
      // configurator sends false once the new one has actually presented.
      this.sceneSpeaksLoading = true;
      this.setSceneBusy(jsonPayload(data.payload) === true);
    } else if (data.type === "CURRENT_QUERY_STRING") {
      var nextQuery = jsonPayload(data.payload);
      if (typeof nextQuery === "string") {
        this.currentProductQuery = normalizeQueryString(nextQuery);
      }
    } else if (data.type === "CURRENT_SKU") {
      // `{ skuString, skuMap }` from the configurator; a bare string from
      // older embeds. What a retailer's basket wants is the string.
      var skuPayload = jsonPayload(data.payload);
      var nextSku =
        skuPayload && typeof skuPayload.skuString === "string"
          ? skuPayload.skuString
          : typeof skuPayload === "string"
            ? skuPayload
            : "";
      this.sku = nextSku.slice(0, 500);
    } else if (
      data.type === "SELECTED_SELECTIONS" ||
      data.type === "CONFIGURATOR_STATE"
    ) {
      var nextSelections = selectionStateFromPayload(data.payload);
      if (nextSelections !== null && nextSelections !== this.selectionString) {
        this.selectionString = nextSelections;
        this.selectionsReceived = true;
        // The selection lands before the scene starts loading (about 75ms
        // before, in the configurator's own measurements), so assuming busy
        // here is what stops the plus flashing up over the old fabric.
        if (this.sceneSpeaksLoading) this.setSceneBusy(true);
        this.renderOverlay();
        this.syncLauncherAvailability();
        // The modal prevents visitor-driven selection changes. If the initial
        // configurator state arrives during capture, that capture will render
        // the now-current scene, so keep it instead of starting a duplicate.
        this.invalidateProductViews(true);
        this.prepareRoomPhotoForReuse();
        this.emit("selection-change", {
          selectionString: this.selectionString,
        });
        if (this.isOpen()) this.prepareProductViews().catch(function () {});
      }
    } else if (data.type === "ROOM_AI_PRODUCT_VIEWS" && data.requestId) {
      if (
        typeof data.requestId !== "string" ||
        !data.requestId.startsWith(this.productViewRequestPrefix)
      ) return;
      var pending = this.pendingProductViews.get(data.requestId);
      var receivedBitmaps = Array.isArray(data.imageBitmaps)
        ? data.imageBitmaps
        : [];
      if (pending) {
        var imageBitmaps = receivedBitmaps.filter(function (bitmap) {
          return (
            bitmap &&
            bitmap.width > 0 &&
            bitmap.height > 0 &&
            typeof bitmap.close === "function"
          );
        });
        if (
          receivedBitmaps.length >= 1 &&
          receivedBitmaps.length <= MAX_PRODUCT_IMAGES &&
          imageBitmaps.length === receivedBitmaps.length
        ) {
          var requestId = data.requestId;
          var instance = this;
          Promise.all(imageBitmaps.map(imageBitmapToPngBlob))
            .then(function (blobs) {
              if (instance.pendingProductViews.get(requestId) !== pending)
                return;
              instance.pendingProductViews.delete(requestId);
              pending.resolve(blobs);
            })
            .catch(function (error) {
              if (instance.pendingProductViews.get(requestId) !== pending)
                return;
              instance.pendingProductViews.delete(requestId);
              pending.reject(error);
            });
        } else {
          closeImageBitmaps(
            receivedBitmaps.filter(function (bitmap) {
              return bitmap && typeof bitmap.close === "function";
            }),
          );
          this.pendingProductViews.delete(data.requestId);
          // Blob payloads remain readable for older configurator deployments,
          // but current iframes transfer ImageBitmap handles instead.
          var blobs = Array.isArray(data.blobs)
            ? data.blobs.filter(function (blob) {
                return (
                  blob &&
                  typeof blob.size === "number" &&
                  /^image\//.test(blob.type || "")
                );
              })
            : [];
          if (blobs.length >= 1 && blobs.length <= MAX_PRODUCT_IMAGES)
            pending.resolve(blobs);
          else
            pending.reject(
              sdkError(
                "The configurator did not return between one and four usable product views.",
                "PRODUCT_CAPTURE_FAILED",
              ),
            );
        }
      } else {
        closeImageBitmaps(
          receivedBitmaps.filter(function (bitmap) {
            return bitmap && typeof bitmap.close === "function";
          }),
        );
      }
    } else if (data.type === "ROOM_AI_PRODUCT_VIEWS_ERROR" && data.requestId) {
      var failed = this.pendingProductViews.get(data.requestId);
      if (failed) {
        this.pendingProductViews.delete(data.requestId);
        var detail = jsonPayload(data.payload);
        var detailMessage =
          detail && typeof detail.message === "string" ? detail.message : "";
        var notReady =
          detailMessage === "The configured product is still loading" ||
          detailMessage === "Product views are not ready yet";
        failed.reject(
          sdkError(
            notReady
              ? "The configured product is still loading. Please try again in a moment."
              : "The configured product views could not be captured. Please try again.",
            notReady ? "PRODUCT_CAPTURE_NOT_READY" : "PRODUCT_CAPTURE_FAILED",
          ),
        );
      }
    }
  };

  RoomAiInstance.prototype.syncLauncherAvailability = function () {
    if (!this.launcher || !this.launcher.element) return;
    var target = this.launcher.element;
    target.dataset.prophecyAvailability = this.availability;
    // Offering to show a product in a room before the scene knows which
    // product it is showing is offering something that cannot work yet. A
    // shop already confirmed keeps its button in place, disabled, so the page
    // does not reflow the moment the configurator finishes loading. One not
    // yet confirmed shows nothing: in production the button is promised to
    // stay hidden until the shop can generate.
    if (!this.configuratorReady()) {
      target.disabled = true;
      target.setAttribute("aria-busy", "true");
      if (!this.development) {
        target.hidden =
          this.availability === "available" ? this.launcher.originalHidden : true;
      }
      return;
    }
    if (this.development) {
      target.hidden = this.launcher.originalHidden;
      target.disabled = this.launcher.originalDisabled;
      if (this.launcher.originalAriaBusy === null) {
        target.removeAttribute("aria-busy");
      } else {
        target.setAttribute("aria-busy", this.launcher.originalAriaBusy);
      }
      return;
    }
    var available = this.availability === "available";
    target.hidden = available ? this.launcher.originalHidden : true;
    target.disabled = available ? false : true;
    if (this.availability === "checking") {
      target.setAttribute("aria-busy", "true");
    } else if (this.launcher.originalAriaBusy === null) {
      target.removeAttribute("aria-busy");
    } else {
      target.setAttribute("aria-busy", this.launcher.originalAriaBusy);
    }
  };

  /**
   * Answers "may this website offer Room AI" without opening a session.
   *
   * A launcher renders on every product page, so this must not spend the
   * shopper's session allowance or make the organisation's product tables part
   * of a page view. The public answer depends only on the organisation, its
   * public key and the calling origin, so one cached response covers the whole
   * catalogue and is reused across product changes. Product ownership is still
   * checked when the shopper opens the preview and a session is created.
   */
  RoomAiInstance.prototype.confirmAvailable = function () {
    // Partner sessions are minted by the retailer's own backend, so the only
    // way to know whether one is obtainable is to ask for it.
    if (
      this.options.sessionEndpoint ||
      typeof this.options.sessionProvider === "function"
    ) {
      return this.getSession();
    }
    if (this.availabilityFetch) return this.availabilityFetch;
    var instance = this;
    var query =
      "?organizationId=" +
      encodeURIComponent(String(this.config.organizationId)) +
      "&apiKey=" +
      encodeURIComponent(this.config.apiKey);
    this.availabilityFetch = requestJson(
      this.endpoint + "/api/configurator/room-ai/availability" + query,
      { method: "GET" },
    ).then(
      function (body) {
        if (!body || body.available !== true) {
          throw sdkError(
            (body && body.reason) || "Room AI is unavailable for this website.",
            "UNAVAILABLE",
          );
        }
        if (body.access === "signed-in") {
          throw sdkError(
            "This site offers room previews to signed-in customers only, and no sessionEndpoint is configured.",
            "SIGN_IN_REQUIRED",
          );
        }
        instance.access = body.access || "open";
        instance.freeGenerations =
          typeof body.freeGenerationsPerDevice === "number"
            ? body.freeGenerationsPerDevice
            : null;
        if (body.upload) instance.applyUploadLimit(body.upload.maxBytes);
        if (body.generation && typeof body.generation.maxConcurrent === "number") {
          instance.maxConcurrent = Math.max(1, body.generation.maxConcurrent);
        }
        return body;
      },
      function (error) {
        // Only a transport failure is worth retrying; a definitive "no" is
        // cached for the life of the page.
        instance.availabilityFetch = null;
        throw error;
      },
    );
    return this.availabilityFetch;
  };

  RoomAiInstance.prototype.checkAvailability = async function () {
    if (this.destroyed) {
      return {
        available: false,
        code: "DESTROYED",
        message: "This room preview has been closed.",
      };
    }
    if (this.availabilityPromise) return this.availabilityPromise;
    if (
      this.availability === "available" &&
      this.session &&
      new Date(this.session.expiresAt).getTime() > Date.now() + 30000 &&
      this.session.productReference === this.productReference
    ) {
      return { available: true };
    }
    var instance = this;
    this.availability = "checking";
    this.availabilityError = null;
    this.syncLauncherAvailability();
    this.emit("availability-change", { available: false, checking: true });
    var availabilityPromise = (async function () {
      try {
        await instance.confirmAvailable();
        instance.availability = "available";
        instance.availabilityError = null;
        var available = { available: true };
        instance.syncLauncherAvailability();
        instance.emit("availability-change", available);
        return available;
      } catch (error) {
        var unavailableError =
          error instanceof Error
            ? error
            : sdkError("Room AI is unavailable.", "UNAVAILABLE");
        var unavailable = {
          available: false,
          code: unavailableError.code || "UNAVAILABLE",
          message: unavailableError.message,
        };
        instance.availability = "unavailable";
        instance.availabilityError = unavailableError;
        instance.syncLauncherAvailability();
        instance.emit("availability-change", unavailable);
        instance.emit("error", {
          error: unavailableError,
          phase: "availability",
        });
        if (!instance.development) {
          console.error("[prophecy] Room preview unavailable:", unavailableError);
        }
        return unavailable;
      }
    })().finally(function () {
      if (instance.availabilityPromise === availabilityPromise) {
        instance.availabilityPromise = null;
      }
    });
    this.availabilityPromise = availabilityPromise;
    return availabilityPromise;
  };

  RoomAiInstance.prototype.attach = function (button) {
    var target = element(button, "the Room AI button");
    // One launcher per instance. Attaching over an earlier one used to leave
    // its click handler and host behind, outliving destroy().
    this.releaseLauncher();
    var instance = this;
    var handler = async function (event) {
      event.preventDefault();
      if (!instance.development) {
        var availability = await instance.checkAvailability();
        if (!availability.available) return;
      }
      await instance.open();
    };
    var originalDisabled = Boolean(target.disabled);
    var originalHidden = Boolean(target.hidden);
    var originalAriaBusy = target.getAttribute("aria-busy");
    target.addEventListener("click", handler);
    this.launcher = {
      element: target,
      originalDisabled: originalDisabled,
      originalHidden: originalHidden,
      originalAriaBusy: originalAriaBusy,
      cleanup: function () {
        target.removeEventListener("click", handler);
        target.disabled = originalDisabled;
        target.hidden = originalHidden;
        if (originalAriaBusy === null) target.removeAttribute("aria-busy");
        else target.setAttribute("aria-busy", originalAriaBusy);
        delete target.dataset.prophecyAvailability;
      },
    };
    this.syncLauncherAvailability();
    if (!this.development && this.productReference) {
      Promise.resolve().then(function () {
        if (!instance.destroyed) instance.checkAvailability();
      });
    }
    return this;
  };

  RoomAiInstance.prototype.releaseLauncher = function () {
    if (this.launcher) {
      this.launcher.cleanup();
      this.launcher = null;
    }
    return this;
  };

  /** Moves the launcher to a different element, e.g. after an SPA route change. */
  RoomAiInstance.prototype.useLauncher = function (target) {
    if (this.launcher && this.launcher.element === target) return this;
    this.releaseLauncher();
    return this.attach(target);
  };

  RoomAiInstance.prototype.mount = function (target) {
    var container = element(target, "the Room AI mount target");
    var host = document.createElement("span");
    var shadow = host.attachShadow({ mode: "open" });
    shadow.innerHTML = `<style>:host{display:inline-block}button{display:inline-flex;min-height:50px;align-items:center;justify-content:center;padding:0 20px;border:1px solid #111;border-radius:10px;background:#111;color:#fff;box-shadow:0 6px 18px rgba(0,0,0,.14);font:700 13px/1 Inter,ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;cursor:pointer;transition:background-color 150ms ease,transform 120ms cubic-bezier(.23,1,.32,1)}button:active{transform:scale(.97)}button:focus-visible{outline:3px solid rgba(0,0,0,.22);outline-offset:3px}@media(hover:hover) and (pointer:fine){button:hover{background:#333}}@media(prefers-reduced-motion:reduce){button{transition-duration:0ms}}</style><button type="button"></button>`;
    var button = shadow.querySelector("button");
    button.textContent =
      this.options.buttonLabel || "See it in your room";
    container.appendChild(host);
    this.attach(button);
    var previousCleanup = this.launcher.cleanup;
    this.launcher.cleanup = function () {
      previousCleanup();
      host.remove();
    };
    return this;
  };

  /**
   * Puts a control in the top-right of the product imagery itself.
   *
   * Positioned with `fixed` against the target's own rectangle rather than by
   * making the retailer's element a containing block: their layout is theirs,
   * and adding `position: relative` to it can move things we cannot see.
   */
  RoomAiInstance.prototype.mountOverlay = function (target) {
    var element = target || this.iframe;
    if (!element || this.overlay) return this;
    var host = document.createElement("span");
    var shadow = host.attachShadow({ mode: "open" });
    var style = document.createElement("style");
    style.textContent = OVERLAY_STYLES;
    var root = document.createElement("div");
    root.className = "overlay";
    shadow.append(style, root);
    document.body.appendChild(host);

    var instance = this;
    var frame = null;
    var place = function () {
      frame = null;
      if (!instance.overlay) return;
      var rect = element.getBoundingClientRect();
      var visible =
        rect.width > 0 &&
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.top < global.innerHeight;
      root.style.display = visible ? "flex" : "none";
      if (!visible) return;
      // Inset from the corner rather than flush to it, so it does not sit on
      // the edge of whatever the imagery is.
      root.style.top = rect.top + 12 + "px";
      root.style.left = rect.left + "px";
      root.style.width = Math.max(0, rect.width - 24) + "px";
    };
    var schedule = function () {
      if (frame) return;
      frame = global.requestAnimationFrame(place);
    };

    this.overlay = { host: host, root: root, place: schedule, target: element };
    global.addEventListener("scroll", schedule, true);
    global.addEventListener("resize", schedule);
    var observer =
      typeof global.ResizeObserver === "function"
        ? new global.ResizeObserver(schedule)
        : null;
    if (observer) observer.observe(element);
    this.overlay.cleanup = function () {
      global.removeEventListener("scroll", schedule, true);
      global.removeEventListener("resize", schedule);
      if (observer) observer.disconnect();
      if (frame) global.cancelAnimationFrame(frame);
      host.remove();
    };

    this.renderOverlay();
    schedule();
    return this;
  };

  /**
   * Draws whichever of the three states the overlay is in.
   *
   * Nothing to show yet, so open the dialog and take them through it; work
   * already saved, so add to it in place; or a preview being made right now.
   */
  /**
   * Builds the overlay once. Later renders change attributes and image
   * sources, never the elements themselves.
   *
   * Replacing the DOM on every state change was why the corner could not
   * transition and why the cards jumped: a fresh element has no previous
   * value to animate from, and a keyframe on it always replays.
   */
  RoomAiInstance.prototype.ensureOverlayShell = function () {
    if (!this.overlay || this.overlay.shell) return;
    var instance = this;
    var root = this.overlay.root;

    var pill = document.createElement("button");
    pill.type = "button";
    pill.className = "pill";
    var pillLabel = document.createElement("span");
    pillLabel.textContent = "View this product in your room";
    pill.appendChild(pillLabel);
    pill.addEventListener("click", function () {
      instance.open();
    });

    var stack = document.createElement("div");
    stack.className = "stack";
    var cards = document.createElement("button");
    cards.type = "button";
    cards.className = "cards";
    cards.setAttribute("aria-label", "Open your room previews");
    cards.addEventListener("click", function () {
      instance.open();
    });

    var corner = document.createElement("button");
    corner.type = "button";
    corner.className = "corner";
    corner.innerHTML =
      '<span class="face face-add"><svg viewBox="0 0 16 16" aria-hidden="true">' +
      '<path d="M8 3.2v9.6M3.2 8h9.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>' +
      '<span class="face face-busy">' +
      generationClockMarkup(false) +
      "</span>" +
      '<span class="face face-done"><svg viewBox="0 0 80 80" aria-hidden="true">' +
      '<circle cx="40" cy="40" r="35"></circle>' +
      '<path d="M25 41.5 35.5 52 56 30"></path></svg></span>';
    corner.addEventListener("click", function (event) {
      event.stopPropagation();
      if (instance.isGeneratingCurrent() || instance.justFinished) return;
      if (!instance.canStartGeneration()) return;
      if (instance.roomPhoto) {
        instance.generate().catch(function () {});
        return;
      }
      instance.open();
    });

    stack.append(cards, corner);
    root.append(pill, stack);
    this.overlay.shell = { pill: pill, stack: stack, cards: cards, corner: corner };
  };

  /**
   * Whether the configurator is up and showing something.
   *
   * Deliberately "has it spoken to us at all" rather than "have selections
   * arrived": a product with no options never sends any, and gating on those
   * would hide the control on that product forever. Any message means the
   * iframe has booted and its bridge is live.
   */
  RoomAiInstance.prototype.configuratorReady = function () {
    if (this.productSource !== "ov25-configurator") return true;
    return this.configuratorSpoke && Number.isInteger(this.productId);
  };

  /** Watches the iframe so a load counts as the scene being up. */
  RoomAiInstance.prototype.watchConfiguratorLoad = function () {
    if (!this.iframe || this.configuratorSpoke) return;
    var instance = this;
    var ready = function () {
      if (instance.configuratorSpoke || instance.destroyed) return;
      instance.configuratorSpoke = true;
      instance.syncLauncherAvailability();
      instance.renderOverlay();
    };
    this.iframe.addEventListener("load", ready);
    // Already loaded before we attached, which is the common case for a
    // script that runs after the page.
    try {
      if (this.iframe.contentDocument &&
          this.iframe.contentDocument.readyState === "complete") {
        ready();
      }
    } catch (_) {
      // Cross-origin, so the load event is the only signal available.
    }
  };

  RoomAiInstance.prototype.renderOverlay = function () {
    if (!this.overlay) return;
    this.ensureOverlayShell();
    var shell = this.overlay.shell;
    var root = this.overlay.root;

    // Nothing here means anything until the scene knows what it is showing.
    if (!this.configuratorReady()) {
      root.style.visibility = "hidden";
      return;
    }
    root.style.visibility = "visible";

    var designs = this.libraryDesigns();
    var current = this.designForCurrentConfiguration(designs);
    var showStack = designs.length > 0;
    shell.pill.hidden = showStack;
    shell.stack.hidden = !showStack;

    // Whether this configuration is being made, not whether anything is:
    // change the fabric mid-generation and the corner offers to make that one
    // too, while the first carries on.
    var state = this.isGeneratingCurrent()
      ? "busy"
      : this.justFinished
        ? "done"
        : current
          ? "none"
          : // Offering to add the new fabric before it is on screen offers the
            // old one: the picture would be of whatever is still painted.
            this.sceneBusy
            ? "none"
            : "add";
    shell.corner.hidden = state === "none";
    // At the account's limit there is nothing a press could do, so it says so
    // rather than starting something the server would refuse.
    shell.corner.disabled = state === "add" && !this.canStartGeneration();
    // The ring in the corner counts this configuration's generation, so a
    // second one running elsewhere cannot drive it.
    var mine = this.pending.get(this.configurationKey());
    var cornerClock = shell.corner.querySelector(".generation-clock");
    if (mine) {
      cornerClock.setAttribute("data-generation", mine.id);
      this.updateGenerationClocks();
    } else {
      cornerClock.removeAttribute("data-generation");
    }
    var previous = shell.corner.getAttribute("data-state");
    shell.corner.setAttribute("data-state", state);
    if (state !== "none") {
      shell.corner.setAttribute(
        "aria-label",
        state === "busy"
          ? "Making your room preview"
          : state === "done"
            ? "Room preview ready"
            : shell.corner.disabled
              ? "Finishing your other room previews"
              : "Add this product to your rooms",
      );
      // The tick draws itself, and a keyframe on an element that never leaves
      // the page needs restarting by hand.
      if (state === "done" && previous !== "done") {
        var tick = shell.corner.querySelector(".face-done path");
        tick.style.animation = "none";
        void tick.offsetWidth;
        tick.style.animation = "";
      }
    }

    if (showStack) this.renderOverlayCards(designs, current);
  };

  /** Updates the three cards in place, so only genuinely new ones animate. */
  RoomAiInstance.prototype.renderOverlayCards = function (designs, current) {
    var cards = this.overlay.shell.cards;
    var behind = designs.filter(function (design) {
      return design !== current;
    });
    // Furthest back first, so the newest paints on top.
    var ordered = (
      current ? [behind[1], behind[0], current] : [behind[2], behind[1], behind[0]]
    ).filter(Boolean);
    var classes = ["behind-2", "behind-1", ""];
    var offset = 3 - ordered.length;

    while (cards.children.length > ordered.length) {
      cards.removeChild(cards.lastChild);
    }
    ordered.forEach(function (design, index) {
      var card = cards.children[index];
      if (!card) {
        card = document.createElement("span");
        card.appendChild(document.createElement("img"));
        cards.appendChild(card);
      }
      var depth = classes[index + offset];
      card.className = "card" + (depth ? " " + depth : "");
      var image = card.firstChild;
      if (image.getAttribute("src") !== design.url) {
        image.setAttribute("src", design.url);
        image.alt = "";
        // Only a card showing something it was not showing before is new.
        if (index === ordered.length - 1 && this.freshDesign) {
          card.classList.add("fresh");
        }
      }
    }, this);
    this.freshDesign = false;
  };

  /** Shows the tick, then hands over to the previews it just made. */
  RoomAiInstance.prototype.flashFinished = function () {
    if (!this.overlay) return;
    var instance = this;
    this.justFinished = true;
    this.freshDesign = true;
    if (this.finishedTimer) global.clearTimeout(this.finishedTimer);
    this.finishedTimer = global.setTimeout(function () {
      instance.finishedTimer = null;
      instance.justFinished = false;
      instance.renderOverlay();
    }, 1100);
  };

  RoomAiInstance.prototype.unmountOverlay = function () {
    if (this.finishedTimer) {
      global.clearTimeout(this.finishedTimer);
      this.finishedTimer = null;
    }
    if (!this.overlay) return this;
    this.overlay.cleanup();
    this.overlay = null;
    return this;
  };

  RoomAiInstance.prototype.mountDefaultLauncher = function () {
    var container = document.createElement("div");
    container.dataset.prophecyAutoLauncher = "true";
    container.style.cssText =
      "position:fixed;right:max(16px,env(safe-area-inset-right));bottom:max(16px,env(safe-area-inset-bottom));z-index:2147482000;max-width:calc(100vw - 32px)";
    document.body.appendChild(container);
    this.mount(container);
    var previousCleanup = this.launcher.cleanup;
    this.launcher.cleanup = function () {
      previousCleanup();
      container.remove();
    };
    return this;
  };

  RoomAiInstance.prototype.ensureUi = function () {
    if (this.ui) return;
    var created = createUi(this);
    var root = created.root;
    var instance = this;
    this.ui = {
      host: created.host,
      root: root,
      backdrop: root.querySelector(".backdrop"),
      dialog: root.querySelector(".dialog"),
      error: root.querySelector(".error"),
      input: root.querySelector(".room-input"),
      cameraInput: root.querySelector(".camera-input"),
      phoneQr: root.querySelector(".phone-qr"),
      phoneLink: root.querySelector(".phone-link"),
      phoneStatus: root.querySelector(".phone-status span:last-child"),
      phoneQrPlaceholder: root.querySelector(".qr-placeholder"),
      drop: root.querySelector(".drop"),
      recentPhotos: root.querySelector(".recent-photos"),
      recentPhotoList: root.querySelector(".recent-photo-list"),
      preview: root.querySelector(".preview"),
      resultCarousel: root.querySelector(".result-carousel"),
      resultThumbnails: root.querySelector(".result-thumbnails"),
      orderProduct: root.querySelector(".order-product"),
      generatingTitle: root.querySelector(".generating-title"),
      generatingCopy: root.querySelector(".generating-copy"),
      generatingProgress: root.querySelector(".generation-progress"),
      generatingTime: root.querySelector(".generation-time"),
      libraryDesignsSection: root.querySelector(".library-designs-section"),
      libraryDesigns: root.querySelector(".library-designs"),
      libraryRooms: root.querySelector(".library-rooms"),
      addRoom: root.querySelector(".add-room"),
      title: root.querySelector("#room-ai-title"),
      subtitle: root.querySelector(".subtitle"),
      views: {
        upload: root.querySelector(".upload-view"),
        library: root.querySelector(".library-view"),
        phone: root.querySelector(".phone-view"),
        preview: root.querySelector(".preview-view"),
        generating: root.querySelector(".generating-view"),
        result: root.querySelector(".result-view"),
      },
    };
    root.querySelector(".close").addEventListener("click", function () {
      instance.close();
    });
    root.querySelector(".cancel").addEventListener("click", function () {
      instance.close();
    });
    root
      .querySelectorAll(".preview-action, .another")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          instance.reset();
          instance.showView("upload");
        });
      });
    root.querySelector(".generate").addEventListener("click", function () {
      instance.generate();
    });
    root
      .querySelector(".continue-shopping")
      .addEventListener("click", function () {
        instance.close();
      });
    this.ui.orderProduct.addEventListener("click", function () {
      instance.orderSelectedPreview();
    });
    this.ui.resultCarousel.addEventListener(
      "scroll",
      function () {
        instance.handleCarouselScroll();
      },
      { passive: true },
    );
    root.querySelector(".phone-choice").addEventListener("click", function () {
      instance.startPhoneHandoff();
    });
    root.querySelector(".phone-back").addEventListener("click", function () {
      instance.showView("upload");
    });
    root.querySelector(".copy-link").addEventListener("click", function () {
      instance.copyPhoneLink();
    });
    [this.ui.input, this.ui.cameraInput].forEach(function (input) {
      input.addEventListener("change", function () {
        if (input.files && input.files[0]) instance.selectPhoto(input.files[0]);
      });
    });
    [
      [this.ui.drop, this.ui.input],
      [root.querySelector(".camera-choice"), this.ui.cameraInput],
    ].forEach(function (pair) {
      pair[0].addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        pair[1].click();
      });
    });
    ["dragenter", "dragover"].forEach(function (type) {
      instance.ui.drop.addEventListener(type, function (event) {
        event.preventDefault();
        instance.ui.drop.classList.add("drag");
      });
    });
    ["dragleave", "drop"].forEach(function (type) {
      instance.ui.drop.addEventListener(type, function (event) {
        event.preventDefault();
        instance.ui.drop.classList.remove("drag");
      });
    });
    this.ui.drop.addEventListener("drop", function (event) {
      var file = event.dataTransfer && event.dataTransfer.files[0];
      if (file) instance.selectPhoto(file);
    });
    this.ui.addRoom.addEventListener("click", function () {
      instance.showView("upload");
    });
    this.ui.backdrop.addEventListener("mousedown", function (event) {
      if (event.target === instance.ui.backdrop) instance.close();
    });
    this.renderRecentRoomPhotos();
  };

  RoomAiInstance.prototype.showError = function (message) {
    this.ensureUi();
    this.ui.error.textContent = message || "";
    this.ui.error.hidden = !message;
  };

  RoomAiInstance.prototype.showView = function (name) {
    var previousView = this.currentView;
    this.currentView = name;
    Object.keys(this.ui.views).forEach(function (key) {
      this.ui.views[key].hidden = key !== name;
    }, this);
    if (name === "upload") this.renderRecentRoomPhotos();
    if (name === "library") this.renderLibrary();
    this.applyHeaderCopy(name);
    this.showError("");
    if (previousView !== name) {
      this.emit("view-change", { view: name, previousView: previousView });
    }
  };

  RoomAiInstance.prototype.applyHeaderCopy = function (view) {
    if (!this.ui || !this.ui.title) return;
    var library = view === "library";
    this.ui.title.textContent = library
      ? "Your room previews"
      : "Picture it in your space";
    this.ui.subtitle.textContent = library
      ? "Pick up where you left off, or add another room."
      : "Bring the product into a photo of your room in moments.";
  };

  /**
   * The design already made for exactly this product and configuration.
   *
   * A colourway is part of the identity: the same sofa in a different fabric is
   * a different thing to look at, so it gets its own preview rather than
   * reusing one that shows the wrong material.
   */
  /**
   * What is on screen right now, as one string.
   *
   * The same three things `designForCurrentConfiguration` matches on, so a
   * generation in flight and a preview already made agree about what counts as
   * the same picture. Changing the fabric changes this, which is the whole
   * point: the one being made and the one being asked for are different keys.
   */
  function configurationKeyFor(productReference, selectionString, room) {
    room = room || {};
    return [
      productReference || "",
      selectionString || "",
      room.fingerprint || room.historyId || "",
    ].join("\u0000");
  }

  RoomAiInstance.prototype.configurationKey = function () {
    return configurationKeyFor(
      this.productReference,
      this.selectionString,
      this.roomPhoto,
    );
  };

  /**
   * Re-files every generation made from this photo under its settled key.
   *
   * The fingerprint arrives a moment after the photo does, and a generation
   * begun inside that moment was filed under the record id. Left there, the
   * configuration on screen would stop counting as being made the instant the
   * fingerprint landed, and the corner would offer to make it a second time.
   */
  RoomAiInstance.prototype.rekeyPendingFor = function (photo) {
    var moved = [];
    this.pending.forEach(function (entry, key) {
      if (entry.roomPhoto !== photo) return;
      var next = configurationKeyFor(
        entry.productReference,
        entry.selectionString,
        photo,
      );
      if (next !== key) moved.push({ from: key, to: next, entry: entry });
    });
    moved.forEach(function (move) {
      this.pending.delete(move.from);
      move.entry.key = move.to;
      this.pending.set(move.to, move.entry);
    }, this);
  };

  /** Whether anything at all is being made. */
  RoomAiInstance.prototype.isGenerating = function () {
    return this.pending.size > 0;
  };

  /** Whether what is on screen right now is being made. */
  RoomAiInstance.prototype.isGeneratingCurrent = function () {
    return this.pending.has(this.configurationKey());
  };

  /**
   * Whether the scene on screen is still catching up with the selection.
   *
   * Held with a long stop so a message that never arrives cannot leave the
   * control waiting forever: after that the scene is treated as settled, which
   * is the behaviour of a configurator that never reports loading at all.
   */
  RoomAiInstance.prototype.setSceneBusy = function (busy) {
    if (this.sceneSettleTimer) {
      global.clearTimeout(this.sceneSettleTimer);
      this.sceneSettleTimer = null;
    }
    if (busy) {
      var instance = this;
      this.sceneSettleTimer = global.setTimeout(function () {
        instance.sceneSettleTimer = null;
        instance.setSceneBusy(false);
      }, SCENE_SETTLE_TIMEOUT_MS);
    }
    if (this.sceneBusy === busy) return;
    this.sceneBusy = busy;
    this.renderOverlay();
  };

  /** Waits for the fabric on screen to be the one that was chosen. */
  RoomAiInstance.prototype.whenSceneSettled = function () {
    if (!this.sceneBusy) return Promise.resolve();
    var instance = this;
    return new Promise(function (resolve) {
      var poll = global.setInterval(function () {
        if (!instance.sceneBusy || instance.destroyed) {
          global.clearInterval(poll);
          resolve();
        }
      }, 50);
    });
  };

  /** Records that this configuration is now being made, and names it. */
  RoomAiInstance.prototype.beginGeneration = function (controller) {
    var key = this.configurationKey();
    this.pendingSequence += 1;
    var entry = {
      key: key,
      id: "g" + this.pendingSequence,
      controller: controller || new global.AbortController(),
      startedAt: Date.now(),
      // What the key was made from, so it can be re-made once the photo's
      // fingerprint is known.
      productReference: this.productReference,
      selectionString: this.selectionString,
      roomPhoto: this.roomPhoto,
    };
    this.pending.set(key, entry);
    return entry;
  };

  /** Stops everything in flight. Every one of them, not just the last. */
  RoomAiInstance.prototype.abortGenerations = function () {
    this.pending.forEach(function (entry) {
      entry.controller.abort();
    });
    this.pending.clear();
    if (this.generationController) this.generationController.abort();
    this.generationController = null;
  };

  /** Whether there is room to start another one. */
  RoomAiInstance.prototype.canStartGeneration = function () {
    return this.pending.size < this.maxConcurrent;
  };

  RoomAiInstance.prototype.designForCurrentConfiguration = function (designs) {
    var reference = this.productReference;
    var selection = this.selectionString || "";
    var room = this.roomPhoto || {};
    return (designs || this.libraryDesigns()).find(function (design) {
      if (design.productReference !== reference) return false;
      if ((design.selectionString || "") !== selection) return false;
      // The bytes are the truth: the same photograph uploaded again, or
      // restored into a fresh page, is the same room whatever its record says.
      if (design.roomPhotoFingerprint && room.fingerprint) {
        return design.roomPhotoFingerprint === room.fingerprint;
      }
      // Previews saved before rooms were recorded have nothing to compare, so
      // they still count rather than being regenerated on sight.
      if (!design.roomPhotoId || !room.historyId) return true;
      return design.roomPhotoId === room.historyId;
    });
  };

  /** Everything this shopper has already made, newest first. */
  RoomAiInstance.prototype.libraryDesigns = function () {
    var stored = this.localHistoryEnabled
      ? readStoredRoomPreviews(this.previewHistoryStorageKey)
      : [];
    return mergePreviews(stored, this.accountPreviews).slice(0, PREVIEW_MAX_COUNT);
  };

  /**
   * The view a shopper should land on.
   *
   * Never the last view they happened to be looking at: leaving the dialog on
   * the phone-handoff screen and coming back to it is a dead end, and the
   * room they already chose is almost always what they want next.
   */
  RoomAiInstance.prototype.landingView = function () {
    // With a room already chosen and previews already made, the useful screen
    // is the previews: the current configuration either has one or is about to.
    if (this.roomPhoto && this.libraryDesigns().length) return "result";
    if (this.roomPhoto) return "preview";
    if (this.libraryDesigns().length || this.recentRoomPhotos.length) {
      return "library";
    }
    return "upload";
  };

  /**
   * Starts a preview for the current configuration if there is not one yet.
   *
   * Only ever from a room the shopper already gave us, and only for a
   * configuration with nothing to show, so opening the dialog twice on the same
   * product does not generate twice.
   */
  /**
   * Resolves once the configurator has reported both its product and its
   * configuration.
   *
   * On a fresh page the fabric is unknown until the iframe says so, and a
   * preview made against an empty configuration matches nothing already
   * saved, so it gets generated a second time.
   */
  RoomAiInstance.prototype.whenConfigurationReady = async function (timeoutMs) {
    if (this.productSource !== "ov25-configurator") return;
    // Capturing mid-swap photographs the fabric being replaced, so the picture
    // would be of something the shopper did not choose.
    await this.whenSceneSettled();
    if (Number.isInteger(this.productId) && this.selectionsReceived) {
      return;
    }
    var instance = this;
    this.requestProductId();
    return new Promise(function (resolve) {
      var settled = false;
      var finish = function () {
        if (settled) return;
        settled = true;
        global.clearInterval(poll);
        global.clearTimeout(timer);
        resolve();
      };
      var poll = global.setInterval(function () {
        if (
          instance.destroyed ||
          (Number.isInteger(instance.productId) && instance.selectionsReceived)
        ) {
          finish();
        }
      }, 50);
      var timer = global.setTimeout(function () {
        instance.selectionsReceived = true;
        finish();
      }, timeoutMs || 4000);
    });
  };

  RoomAiInstance.prototype.generateIfMissing = async function () {
    // Deliberately any generation, not this configuration's: opening the dialog
    // while one is already running should show it, never quietly start another.
    if (this.isGenerating() || !this.roomPhoto || this.destroyed) return;
    await this.whenConfigurationReady(4000);
    if (this.isGenerating() || this.destroyed) return;
    if (!this.productReference) return;
    if (this.designForCurrentConfiguration()) return;
    this.generate().catch(function () {});
  };

  RoomAiInstance.prototype.renderLibrary = function () {
    if (!this.ui) return;
    var instance = this;
    var designs = this.libraryDesigns();

    this.ui.libraryDesignsSection.hidden = designs.length === 0;
    this.ui.libraryDesigns.replaceChildren();
    designs.forEach(function (design, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "library-item";
      button.setAttribute("aria-label", "Open design " + (index + 1));
      var image = document.createElement("img");
      image.src = design.url;
      image.alt = "";
      button.appendChild(image);
      button.addEventListener("click", function () {
        instance.showDesign(designs, index);
      });
      instance.ui.libraryDesigns.appendChild(button);
    });

    this.clearLibraryRoomUrls();
    this.ui.libraryRooms.replaceChildren();
    if (this.recentRoomPhotos.length === 0) {
      var empty = document.createElement("p");
      empty.className = "library-empty";
      empty.textContent = "No rooms saved yet.";
      this.ui.libraryRooms.appendChild(empty);
      return;
    }
    this.recentRoomPhotos.forEach(function (photo, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "library-item";
      button.setAttribute("aria-label", "Use room " + (index + 1));
      var image = document.createElement("img");
      var url = URL.createObjectURL(photo.blob);
      instance.libraryRoomUrls.push(url);
      image.src = url;
      image.alt = "";
      button.appendChild(image);
      button.addEventListener("click", function () {
        instance.useRecentRoomPhoto(photo.historyId);
      });
      instance.ui.libraryRooms.appendChild(button);
    });
  };

  RoomAiInstance.prototype.clearLibraryRoomUrls = function () {
    this.libraryRoomUrls.forEach(function (url) {
      URL.revokeObjectURL(url);
    });
    this.libraryRoomUrls = [];
  };

  /**
   * Fills the previews screen from saved work, with this configuration first.
   *
   * Used when the dialog opens on previews rather than after a generation, so
   * the shopper sees what they already have while anything missing is made.
   */
  RoomAiInstance.prototype.showSavedDesigns = function () {
    var designs = this.libraryDesigns();
    if (!designs.length) return;
    var current = this.designForCurrentConfiguration(designs);
    this.carouselItems = designs;
    this.carouselIndex = current ? designs.indexOf(current) : 0;
    this.renderResultCarousel();
    this.scrollCarouselTo(this.carouselIndex);
  };

  /** Opens one saved design in the result view, without regenerating it. */
  RoomAiInstance.prototype.showDesign = function (designs, index) {
    this.carouselItems = designs;
    this.carouselIndex = index;
    this.renderResultCarousel();
    this.showView("result");
    this.scrollCarouselTo(index);
  };

  RoomAiInstance.prototype.setGeneratingState = function (title, copy) {
    this.ensureUi();
    this.ui.generatingTitle.textContent = title;
    this.ui.generatingCopy.textContent = copy;
  };

  RoomAiInstance.prototype.startGenerationClock = function () {
    // One interval drives every clock on the page. Restarting it on a second
    // generation would reset the first one's ring back to empty.
    if (this.generationClockId) {
      this.updateGenerationClocks();
      return;
    }
    var instance = this;
    this.generationClockId = global.setInterval(function () {
      instance.updateGenerationClocks();
    }, 50);
    this.updateGenerationClocks();
  };

  /**
   * Moves every ring on to where its own generation has got to.
   *
   * A clock that names a generation counts that one. One that names none is
   * the single full-screen clock, which belongs to the oldest still running.
   */
  RoomAiInstance.prototype.updateGenerationClocks = function () {
    var byId = new Map();
    var oldest = null;
    this.pending.forEach(function (entry) {
      byId.set(entry.id, entry);
      if (!oldest || entry.startedAt < oldest.startedAt) oldest = entry;
    });
    if (!oldest) return;
    var now = Date.now();
    this.clockRoots().forEach(function (root) {
      root.querySelectorAll(".generation-clock").forEach(function (clock) {
        var id = clock.getAttribute("data-generation");
        var entry = id ? byId.get(id) : oldest;
        if (!entry) return;
        var elapsedMs = Math.max(0, now - entry.startedAt);
        var progress =
          elapsedMs / (elapsedMs + GENERATION_PROGRESS_HALF_LIFE_MS);
        clock.querySelectorAll(".generation-time").forEach(function (node) {
          node.textContent = (elapsedMs / 1000).toFixed(2) + "s";
        });
        clock.querySelectorAll(".generation-progress").forEach(function (node) {
          node.style.strokeDashoffset = String(100 - progress * 100);
        });
      });
    });
  };

  /** Every place a generating clock can be showing. */
  RoomAiInstance.prototype.clockRoots = function () {
    var roots = [];
    if (this.ui) roots.push(this.ui.root);
    if (this.overlay) roots.push(this.overlay.root);
    return roots;
  };

  RoomAiInstance.prototype.stopGenerationClock = function () {
    // Whatever is left still needs counting.
    if (this.isGenerating()) return;
    if (this.generationClockId) {
      global.clearInterval(this.generationClockId);
      this.generationClockId = null;
    }
  };

  RoomAiInstance.prototype.open = async function () {
    if (this.destroyed || this.openState) return this.openPromise;
    if (!this.development) {
      var availability = await this.checkAvailability();
      if (!availability.available) return;
    }
    this.ensureUi();
    // Chosen synchronously so the first paint is right, and remembered so the
    // re-check below cannot overwrite a shopper who has already navigated.
    var landedView = this.landingView();
    this.showView(landedView);
    this.openState = true;
    this.pageScrollLocked = true;
    lockPageScroll();
    if (this.closeTimer) {
      global.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    if (
      !this.accountHistoryLoaded &&
      this.options.history &&
      Number.isInteger(this.config.organizationId)
    ) {
      this.accountHistoryLoaded = true;
      this.accountHistoryRestorePromise = this.restoreAccountHistory();
    }
    var instance = this;
    this.openPromise = (async function () {
      await Promise.all([
        instance.photoRestorePromise,
        instance.recentPhotosRestorePromise,
      ]);
      if (instance.destroyed || !instance.openState) return;
      if (instance.roomPhoto) {
        instance.rememberRoomPhoto(instance.roomPhoto);
        if (instance.localHistoryEnabled) {
          saveStoredRoomPhoto(
            instance.roomPhotoStorageKey,
            instance.roomPhoto,
          ).catch(function () {});
        }
        instance.renderRoomPhoto();
      }
      // The saved room and rooms list only finish loading here, so the landing
      // view is worked out again now that they are known.
      if (instance.currentView === landedView) {
        instance.showView(instance.landingView());
      }
      if (instance.currentView === "result") {
        instance.showSavedDesigns();
        // Opened on top of work the overlay started: show that it is running
        // rather than an empty strip.
        if (instance.isGenerating()) instance.showPendingSlide();
        instance.generateIfMissing();
      }
      instance.lastFocus = document.activeElement;
      instance.ui.backdrop.hidden = false;
      requestAnimationFrame(function () {
        if (instance.ui && !instance.destroyed && instance.openState) {
          instance.ui.backdrop.classList.add("open");
        }
      });
      document.addEventListener("keydown", instance.handleKeydown);

      instance.ui.root.querySelector(".close").focus();
      instance.requestProductId();
      instance.emit("open", instance.getState());
      instance.prepareProductViews().catch(function () {});
      try {
        await instance.whenProductReady(3000);
        await instance.getSession();
        await Promise.all([
          instance.photoRestorePromise,
          instance.recentPhotosRestorePromise,
        ]);
        if (instance.roomPhoto && instance.ui && !instance.destroyed) {
          instance.renderRoomPhoto();
          // The photo may only finish restoring after the landing view was
          // chosen, so a shopper who already has a room still lands on it.
          if (instance.currentView === "upload" || instance.currentView === "library") {
            instance.showView("preview");
          }
        }
        if (!instance.accountHistoryLoaded && instance.options.history) {
          instance.accountHistoryLoaded = true;
          instance.accountHistoryRestorePromise =
            instance.restoreAccountHistory();
          await instance.accountHistoryRestorePromise;
        }
      } catch (error) {
        if (instance.destroyed || isAbortError(error)) return;
        console.error("[prophecy] Room preview unavailable:", error);
        instance.showError(error.message);
        instance.emit("error", { error: error, phase: "session" });
      }
    })().finally(function () {
      instance.openPromise = null;
    });
    return this.openPromise;
  };

  RoomAiInstance.prototype.isOpen = function () {
    return this.openState;
  };

  RoomAiInstance.prototype.close = function () {
    if (!this.ui || !this.openState) return;
    this.openState = false;
    if (this.pageScrollLocked) {
      this.pageScrollLocked = false;
      unlockPageScroll();
    }
    this.ui.backdrop.classList.remove("open");
    document.removeEventListener("keydown", this.handleKeydown);
    var ui = this.ui;
    var instance = this;
    this.closeTimer = global.setTimeout(function () {
      if (!instance.openState) ui.backdrop.hidden = true;
      instance.closeTimer = null;
    }, 160);
    if (this.lastFocus && typeof this.lastFocus.focus === "function")
      this.lastFocus.focus();
    this.emit("close", this.getState());
  };

  RoomAiInstance.prototype.handleKeydown = function (event) {
    if (event.key === "Escape") {
      this.close();
      return;
    }
    if (event.key !== "Tab" || !this.ui) return;
    var focusable = Array.from(
      this.ui.root.querySelectorAll(
        "button:not([disabled]), a[href], [tabindex='0'], input:not([disabled]):not([tabindex='-1'])",
      ),
    ).filter(function (item) {
      return !item.closest("[hidden]");
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && this.ui.root.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && this.ui.root.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  RoomAiInstance.prototype.restoreRoomPhoto = async function () {
    var photo = await readStoredRoomPhoto(this.roomPhotoStorageKey);
    if (!photo || this.destroyed || this.roomPhoto) return;
    this.roomPhoto = photo;
    // Otherwise a restored room only gets its fingerprint once the dialog
    // opens, and the widget cannot match it to its saved previews until then.
    this.fingerprintRoomPhoto(photo);
    // Deliberately does not set the view. landingView() reads the photo, so
    // having two things decide the opening view is how one of them gets stale.
    if (this.ui) this.renderRoomPhoto();
  };

  RoomAiInstance.prototype.restoreRecentRoomPhotos = async function () {
    var photos = await readStoredRecentRoomPhotos(this.roomPhotoStorageKey);
    if (this.destroyed) return;
    this.recentRoomPhotos = photos;
    if (this.ui) this.renderRecentRoomPhotos();
  };

  RoomAiInstance.prototype.beginHistoryEpoch = function () {
    this.historyEpoch += 1;
    this.historyController.abort();
    this.historyController = new global.AbortController();
    return this.historyEpoch;
  };

  RoomAiInstance.prototype.enqueueHistory = function (operation, epoch) {
    var instance = this;
    var expectedEpoch = epoch === undefined ? this.historyEpoch : epoch;
    var controller = this.historyController;
    var run = this.historyQueue
      .catch(function () {})
      .then(function () {
        if (
          instance.destroyed ||
          expectedEpoch !== instance.historyEpoch ||
          controller.signal.aborted
        ) {
          return undefined;
        }
        return operation(controller.signal);
      });
    this.historyQueue = run.catch(function () {});
    return run;
  };

  RoomAiInstance.prototype.restoreAccountHistory = async function () {
    var history = this.options.history;
    if (!history || typeof history.load !== "function") return;
    if (!Number.isInteger(this.config.organizationId)) return;
    if (this.historyLoadController) this.historyLoadController.abort();
    var controller = new global.AbortController();
    this.historyLoadController = controller;
    var accountEpoch = this.accountEpoch;
    try {
      var loaded = await history.load({
        organizationId: this.config.organizationId,
        productId: this.productId,
        productReference: this.productReference,
        productSource: this.productSource,
        signal: controller.signal,
      });
      if (
        this.destroyed ||
        controller.signal.aborted ||
        accountEpoch !== this.accountEpoch
      ) {
        return;
      }
      var roomRecords =
        loaded && Array.isArray(loaded.roomPhotos) ? loaded.roomPhotos : [];
      var maxHistoryBytes = HISTORY_MAX_IMAGE_BYTES;
      var remainingHistoryBytes = HISTORY_TOTAL_IMAGE_BYTES;
      var accountPhotos = [];
      for (
        var index = 0;
        index < Math.min(roomRecords.length, RECENT_PHOTO_MAX_COUNT);
        index += 1
      ) {
        throwIfAborted(controller.signal);
        var item = roomRecords[index];
        try {
          if (!item || typeof item.id !== "string" || !item.id) continue;
          var blob = item.blob instanceof Blob ? item.blob : null;
          if (!blob && typeof item.url === "string") {
            blob = await fetchBoundedHistoryImage(
              item.url,
              controller.signal,
              remainingHistoryBytes,
            );
          }
          if (
            !blob ||
            !/^image\/(jpeg|png|webp)$/.test(blob.type) ||
            !blob.size ||
            blob.size > maxHistoryBytes ||
            blob.size > remainingHistoryBytes ||
            !Number.isFinite(Number(item.width)) ||
            !Number.isFinite(Number(item.height)) ||
            Number(item.width) <= 0 ||
            Number(item.height) <= 0
          ) {
            continue;
          }
          remainingHistoryBytes -= blob.size;
          accountPhotos.push({
            blob: blob,
            width: Number(item.width),
            height: Number(item.height),
            aspectRatio:
              typeof item.aspectRatio === "string"
                ? item.aspectRatio
                : nearestAspect(Number(item.width), Number(item.height)),
            historyId: "account:" + item.id,
            accountId: item.id,
            accountBacked: true,
            savedAt: Number.isFinite(Number(item.savedAt))
              ? Number(item.savedAt)
              : Date.now(),
          });
        } catch (error) {
          if (isAbortError(error)) throw error;
        }
      }
      if (
        this.destroyed ||
        controller.signal.aborted ||
        accountEpoch !== this.accountEpoch
      ) {
        return;
      }
      this.recentRoomPhotos = accountPhotos
        .concat(
          this.recentRoomPhotos.filter(function (photo) {
            return !photo.accountBacked;
          }),
        )
        .slice(0, RECENT_PHOTO_MAX_COUNT);
      this.accountPreviews =
        loaded && Array.isArray(loaded.results)
          ? loaded.results
              .filter(validPreviewRecord)
              .map(normalizedPreviewRecord)
              .slice(0, PREVIEW_MAX_COUNT)
          : [];
      this.renderRecentRoomPhotos();
      this.emit("history-load", {
        roomPhotoCount: accountPhotos.length,
        resultCount: this.accountPreviews.length,
      });
    } catch (error) {
      if (isAbortError(error)) return;
      this.emit("history-error", { operation: "load", error: error });
    } finally {
      if (this.historyLoadController === controller) {
        this.historyLoadController = null;
      }
    }
  };

  RoomAiInstance.prototype.refreshHistory = async function () {
    this.accountHistoryLoaded = true;
    this.accountHistoryRestorePromise = this.restoreAccountHistory();
    await this.accountHistoryRestorePromise;
    return this.getState();
  };

  RoomAiInstance.prototype.clearRecentPhotoUrls = function () {
    this.recentPhotoUrls.forEach(function (url) {
      URL.revokeObjectURL(url);
    });
    this.recentPhotoUrls = [];
  };

  RoomAiInstance.prototype.renderRecentRoomPhotos = function () {
    if (!this.ui) return;
    this.clearRecentPhotoUrls();
    this.ui.recentPhotoList.replaceChildren();
    this.ui.recentPhotos.hidden = this.recentRoomPhotos.length === 0;
    this.recentRoomPhotos.forEach(function (photo, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "recent-photo";
      button.setAttribute("aria-label", "Use recent room photo " + (index + 1));
      var image = document.createElement("img");
      var url = URL.createObjectURL(photo.blob);
      this.recentPhotoUrls.push(url);
      image.src = url;
      image.alt = "";
      button.appendChild(image);
      button.addEventListener(
        "click",
        function () {
          this.useRecentRoomPhoto(photo.historyId);
        }.bind(this),
      );
      this.ui.recentPhotoList.appendChild(button);
    }, this);
  };

  /** Works out the photo's fingerprint once, then re-files anything made from it. */
  RoomAiInstance.prototype.fingerprintRoomPhoto = function (photo) {
    if (!photo || photo.fingerprint || photo.fingerprinting || !photo.blob) {
      return;
    }
    var instance = this;
    photo.fingerprinting = true;
    roomPhotoFingerprint(photo.blob).then(function (fingerprint) {
      photo.fingerprinting = false;
      if (!fingerprint) return;
      photo.fingerprint = fingerprint;
      instance.rekeyPendingFor(photo);
      if (!instance.destroyed) instance.renderOverlay();
    });
  };

  RoomAiInstance.prototype.rememberRoomPhoto = function (photo) {
    this.fingerprintRoomPhoto(photo);
    if (!photo.historyId) {
      photo.historyId =
        Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
    }
    photo.savedAt = Date.now();
    this.recentRoomPhotos = [photo]
      .concat(
        this.recentRoomPhotos.filter(function (item) {
          return item.historyId !== photo.historyId;
        }),
      )
      .slice(0, RECENT_PHOTO_MAX_COUNT);
    this.renderRecentRoomPhotos();
    if (this.localHistoryEnabled) {
      saveStoredRecentRoomPhotos(
        this.roomPhotoStorageKey,
        this.recentRoomPhotos,
      ).catch(function () {});
    }
  };

  RoomAiInstance.prototype.useRecentRoomPhoto = function (historyId) {
    var photo = this.recentRoomPhotos.find(function (item) {
      return item.historyId === historyId;
    });
    if (!photo) return;
    this.setRoomPhoto(photo, "history");
    this.showView("preview");
  };

  RoomAiInstance.prototype.renderRoomPhoto = function () {
    if (!this.ui || !this.roomPhoto) return;
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.previewUrl = URL.createObjectURL(this.roomPhoto.blob);
    this.ui.preview.src = this.previewUrl;
  };

  RoomAiInstance.prototype.setRoomPhoto = function (photo, source) {
    if (this.localHistoryEnabled) {
      deleteStoredRoomPreviews(this.previewHistoryStorageKey);
    }
    this.roomPhoto = photo;
    this.renderRoomPhoto();
    if (this.ui) {
      this.ui.input.value = "";
      this.ui.cameraInput.value = "";
    }
    this.rememberRoomPhoto(photo);
    if (this.localHistoryEnabled) {
      saveStoredRoomPhoto(this.roomPhotoStorageKey, photo).catch(function () {});
    }
    this.emit("photo-selected", {
      source: source || "device",
      width: photo.width,
      height: photo.height,
      aspectRatio: photo.aspectRatio,
      byteSize: photo.blob.size,
      contentType: photo.blob.type,
      historyId: photo.accountId || photo.historyId,
    });
    if (
      source !== "history" &&
      source !== "account" &&
      this.options.history &&
      typeof this.options.history.saveRoom === "function"
    ) {
      var instance = this;
      var history = this.options.history;
      var historyEpoch = this.historyEpoch;
      var productId = this.productId;
      var productReference = this.productReference;
      var productSource = this.productSource;
      var selectionString = this.selectionString;
      this.enqueueHistory(
        async function (signal) {
          var saved = await history.saveRoom({
            blob: photo.blob,
            width: photo.width,
            height: photo.height,
            aspectRatio: photo.aspectRatio,
            productId: productId,
            productReference: productReference,
            productSource: productSource,
            selectionString: selectionString,
            signal: signal,
          });
          throwIfAborted(signal);
          if (historyEpoch !== instance.historyEpoch || instance.destroyed) return;
          if (saved && typeof saved.id === "string" && saved.id) {
            photo.accountId = saved.id;
            photo.historyId = "account:" + saved.id;
            photo.accountBacked = true;
          }
          instance.emit("history-save", {
            kind: "room-photo",
            id: saved && saved.id,
          });
        },
        historyEpoch,
      )
        .catch(function (error) {
          if (isAbortError(error)) return;
          instance.emit("history-error", {
            operation: "save-room-photo",
            error: error,
          });
        });
    }
  };

  RoomAiInstance.prototype.prepareRoomPhotoForReuse = function () {
    if (!this.roomPhoto || this.isGenerating() || this.currentView !== "result")
      return;
    this.currentView = "preview";
    if (this.ui) {
      this.clearResultCarousel();
      if (this.isOpen()) this.showView("preview");
    }
  };

  RoomAiInstance.prototype.renderRoomResult = function (
    resultUrl,
    productUrl,
    jobId,
    context,
    focus,
  ) {
    var preview = {
      jobId: jobId,
      url: resultUrl,
      productId: context.productId,
      productReference: context.productReference,
      productSource: context.productSource,
      selectionString: context.selectionString,
      // Which room it was made from is part of what makes it that preview.
      roomPhotoId: context.roomPhoto && context.roomPhoto.historyId,
      roomPhotoFingerprint: context.roomPhoto && context.roomPhoto.fingerprint,
      queryString: context.queryString,
      sku: context.sku || "",
      pageUrl: context.pageUrl || "",
      productUrl:
        sameSiteProductUrl(productUrl) ||
        context.productUrl ||
        productUrlForPreview(context.queryString),
      savedAt: Date.now(),
    };
    if (this.localHistoryEnabled) {
      saveStoredRoomPreview(this.previewHistoryStorageKey, preview);
    }
    var localPreviews = this.localHistoryEnabled
      ? readStoredRoomPreviews(this.previewHistoryStorageKey)
      : [normalizedPreviewRecord(preview)];
    this.carouselItems = mergePreviews(
      localPreviews,
      this.accountPreviews,
    ).slice(0, PREVIEW_MAX_COUNT);
    // Only jump to it if it is what the shopper is looking at. One that
    // finished while they moved on joins the strip without snatching the view.
    if (focus !== false) this.carouselIndex = 0;
    this.renderResultCarousel();
  };

  /** The preview being made, shown first among the ones already made. */
  RoomAiInstance.prototype.showPendingSlide = function () {
    if (this.pendingPreview) return;
    this.pendingPreview = true;
    this.carouselIndex = 0;
    this.renderResultCarousel();
    this.scrollCarouselTo(0);
  };

  RoomAiInstance.prototype.clearPendingSlide = function () {
    this.pendingPreview = false;
  };

  /**
   * Slides, thumbnails and the index all count the same entries.
   *
   * The tiles being made are read straight off the generations in flight, so
   * the strip cannot disagree with what is actually happening: three running
   * is three tiles, and one finishing removes its own.
   */
  RoomAiInstance.prototype.carouselEntries = function () {
    var pending = [];
    if (this.pendingPreview) {
      this.pending.forEach(function (entry) {
        pending.push({ pending: true, id: entry.id, startedAt: entry.startedAt });
      });
      pending.sort(function (a, b) {
        return a.startedAt - b.startedAt;
      });
    }
    return pending.concat(this.carouselItems);
  };

  /** Draws whatever is in carouselItems. Shared by a fresh result and the library. */
  RoomAiInstance.prototype.renderResultCarousel = function () {
    if (!this.ui) return;
    var entries = this.carouselEntries();
    this.ui.resultCarousel.replaceChildren();
    this.ui.resultThumbnails.replaceChildren();
    entries.forEach(function (item, index) {
      if (item.pending) {
        var pendingSlide = document.createElement("div");
        pendingSlide.className = "result-slide pending";
        // Whatever shape the room photo is, because that is the shape the
        // preview will arrive in.
        var ratio = this.roomPhoto && this.roomPhoto.aspectRatio;
        if (typeof ratio === "string" && ratio.indexOf(":") > 0) {
          pendingSlide.style.aspectRatio = ratio.replace(":", " / ");
        }
        pendingSlide.innerHTML = generatingMarkup(
          "Bringing it into your room",
          "This usually takes 20 to 30 seconds.",
          item.id,
        );
        this.ui.resultCarousel.appendChild(pendingSlide);

        var pendingThumb = document.createElement("button");
        pendingThumb.type = "button";
        pendingThumb.className = "result-thumbnail pending";
        pendingThumb.setAttribute("aria-label", "The preview being made");
        pendingThumb.innerHTML =
          '<span class="thumbnail-spinner" aria-hidden="true"></span>';
        pendingThumb.addEventListener(
          "click",
          function () {
            this.scrollCarouselTo(index);
          }.bind(this),
        );
        this.ui.resultThumbnails.appendChild(pendingThumb);
        return;
      }
      var slide = document.createElement("div");
      slide.className = "result-slide";
      var wrap = document.createElement("div");
      wrap.className = "result-wrap";
      var image = document.createElement("img");
      image.className = "result";
      image.src = item.url;
      image.alt =
        index === 0
          ? "Current product in your room"
          : "Previous product in your room";
      wrap.appendChild(image);
      slide.appendChild(wrap);
      this.ui.resultCarousel.appendChild(slide);

      var thumbnail = document.createElement("button");
      thumbnail.type = "button";
      thumbnail.className = "result-thumbnail";
      thumbnail.setAttribute(
        "aria-label",
        "Show product preview " + (index + 1) + " of " + entries.length,
      );
      var thumbnailImage = document.createElement("img");
      thumbnailImage.src = item.url;
      thumbnailImage.alt = "";
      thumbnail.appendChild(thumbnailImage);
      thumbnail.addEventListener(
        "click",
        function () {
          this.scrollCarouselTo(index);
        }.bind(this),
      );
      this.ui.resultThumbnails.appendChild(thumbnail);
    }, this);
    this.ui.resultCarousel.scrollLeft = 0;
    this.ui.resultThumbnails.hidden = entries.length < 2;
    this.updateCarouselUi();
  };

  RoomAiInstance.prototype.updateCarouselUi = function () {
    if (!this.ui) return;
    var entries = this.carouselEntries();
    var index = Math.max(
      0,
      Math.min(this.carouselIndex, Math.max(0, entries.length - 1)),
    );
    this.carouselIndex = index;
    var selectedItem = entries[index];
    var selectedProductUrl =
      selectedItem && !selectedItem.pending
        ? sameSiteProductUrl(selectedItem.productUrl)
        : "";
    // Offered when there is somewhere to send the shopper, or the page has
    // asked to handle the order itself. Never for a preview still being made.
    var canOrder =
      Boolean(selectedItem && !selectedItem.pending) &&
      (Boolean(selectedProductUrl) || this.hasOrderHook());
    this.ui.orderProduct.hidden = !canOrder;
    if (selectedProductUrl) {
      this.ui.orderProduct.dataset.url = selectedProductUrl;
    } else {
      delete this.ui.orderProduct.dataset.url;
    }
    Array.from(this.ui.resultThumbnails.children).forEach(
      function (thumbnail, thumbnailIndex) {
        thumbnail.setAttribute(
          "aria-current",
          thumbnailIndex === index ? "true" : "false",
        );
      },
    );
  };

  /** Whether the page has asked to handle "Order this product" itself. */
  RoomAiInstance.prototype.hasOrderHook = function () {
    if (typeof this.options.onOrder === "function") return true;
    var handlers = this.listeners.get("order");
    return Boolean(handlers && handlers.size > 0);
  };

  /**
   * A preview as the page's order handler sees it.
   *
   * Everything a basket needs: the configurator's SKU for that exact
   * configuration, and the page it was generated from, query string and all,
   * so the same configuration can be shown again.
   */
  RoomAiInstance.prototype.orderDetailFor = function (preview) {
    var detail = {
      sku: preview.sku || "",
      pageUrl: preview.pageUrl || "",
      productUrl: sameSiteProductUrl(preview.productUrl),
      productId: preview.productId === undefined ? null : preview.productId,
      productReference: preview.productReference || "",
      productSource: preview.productSource || this.productSource,
      selectionString: preview.selectionString || "",
      queryString: preview.queryString || "",
      jobId: preview.jobId,
      resultUrl: preview.url,
      defaultPrevented: false,
    };
    Object.defineProperty(detail, "preventDefault", {
      value: function () {
        detail.defaultPrevented = true;
      },
      enumerable: false,
    });
    return detail;
  };

  /**
   * "Order this product" for the preview on screen.
   *
   * The page hears about it first and may take over: a handler that calls
   * `preventDefault()` keeps the shopper here, for a basket of its own. With
   * nobody objecting, the shopper goes to the page the preview was made from.
   */
  RoomAiInstance.prototype.orderSelectedPreview = function () {
    var entries = this.carouselEntries();
    var selected = entries[this.carouselIndex];
    if (!selected || selected.pending) return;
    var detail = this.orderDetailFor(selected);
    this.emit("order", detail);
    if (detail.defaultPrevented || !detail.productUrl) return;
    this.navigateTo(detail.productUrl);
  };

  RoomAiInstance.prototype.navigateTo = function (url) {
    global.location.assign(url);
  };

  RoomAiInstance.prototype.scrollCarouselTo = function (index) {
    if (!this.ui) return;
    var entries = this.carouselEntries();
    if (!entries.length) return;
    this.carouselIndex = Math.max(0, Math.min(index, entries.length - 1));
    var left = this.carouselIndex * this.ui.resultCarousel.clientWidth;
    if (typeof this.ui.resultCarousel.scrollTo === "function") {
      this.ui.resultCarousel.scrollTo({ left: left, behavior: "smooth" });
    } else {
      this.ui.resultCarousel.scrollLeft = left;
    }
    this.updateCarouselUi();
  };

  RoomAiInstance.prototype.handleCarouselScroll = function () {
    if (!this.ui || !this.ui.resultCarousel.clientWidth) return;
    var index = Math.round(
      this.ui.resultCarousel.scrollLeft / this.ui.resultCarousel.clientWidth,
    );
    if (index === this.carouselIndex) return;
    this.carouselIndex = index;
    this.updateCarouselUi();
  };

  RoomAiInstance.prototype.clearResultCarousel = function () {
    this.carouselIndex = 0;
    this.carouselItems = [];
    this.pendingPreview = false;
    if (!this.ui) return;
    this.ui.resultCarousel.replaceChildren();
    this.ui.resultThumbnails.replaceChildren();
    this.ui.resultThumbnails.hidden = true;
    this.ui.orderProduct.hidden = true;
    delete this.ui.orderProduct.dataset.url;
  };

  RoomAiInstance.prototype.selectPhoto = async function (file) {
    this.showError("");
    if (!/^image\/(jpeg|png|webp)$/.test(file.type)) {
      this.showError("Choose a JPEG, PNG or WebP room photo.");
      return;
    }
    if (file.size > this.maxUploadBytes) {
      this.showError(
        "Choose a room photo smaller than " +
          Math.floor(this.maxUploadBytes / 1024 / 1024) +
          "MB.",
      );
      return;
    }
    this.clearPhoneHandoff();
    try {
      var photo = await resizeRoomPhoto(file, 2048);
      if (photo.blob.size > this.maxUploadBytes) {
        throw sdkError(
          "The prepared room photo is too large. Choose a smaller image.",
          "IMAGE_TOO_LARGE",
        );
      }
      this.setRoomPhoto(photo);
      this.showView("preview");
    } catch (error) {
      this.showError(error.message || "The room photo could not be opened.");
      this.emit("error", { error: error, phase: "photo" });
    }
  };

  RoomAiInstance.prototype.clearPhoneHandoff = function () {
    if (this.phonePollTimer) global.clearTimeout(this.phonePollTimer);
    this.phonePollTimer = null;
    this.phoneHandoff = null;
  };

  RoomAiInstance.prototype.copyPhoneLink = async function () {
    if (!this.phoneHandoff || !global.navigator.clipboard) return;
    try {
      await global.navigator.clipboard.writeText(this.phoneHandoff.mobileUrl);
      this.ui.root.querySelector(".copy-link").textContent = "Copied";
      global.setTimeout(
        function () {
          if (this.ui && this.phoneHandoff)
            this.ui.root.querySelector(".copy-link").textContent = "Copy link";
        }.bind(this),
        1600,
      );
    } catch (_) {
      this.showError(
        "The link could not be copied. Open the link shown below instead.",
      );
    }
  };

  RoomAiInstance.prototype.startPhoneHandoff = async function () {
    this.ensureUi();
    this.clearPhoneHandoff();
    this.showView("phone");
    this.ui.phoneQr.hidden = true;
    this.ui.phoneQr.removeAttribute("src");
    this.ui.phoneQrPlaceholder.hidden = false;
    this.ui.phoneLink.hidden = true;
    this.ui.phoneStatus.textContent = "Creating a secure link…";
    this.ui.root.querySelector(".copy-link").disabled = true;
    try {
      var session = await this.getSession();
      var handoff = await requestJson(
        this.endpoint + "/api/configurator/room-ai/handoff",
        {
          method: "POST",
          headers: { Authorization: "Bearer " + session.token },
        },
      );
      if (this.destroyed) return;
      this.phoneHandoff = handoff;
      this.emit("phone-handoff-start", {
        expiresAt: handoff.expiresAt,
        mobileUrl: handoff.mobileUrl,
      });
      this.ui.phoneQr.src = handoff.qrDataUrl;
      this.ui.phoneQr.hidden = false;
      this.ui.phoneQrPlaceholder.hidden = true;
      this.ui.phoneLink.href = handoff.mobileUrl;
      this.ui.phoneLink.textContent = "Open phone upload link";
      this.ui.phoneLink.hidden = false;
      this.ui.phoneStatus.textContent = "Waiting for your phone…";
      this.ui.root.querySelector(".copy-link").disabled = false;
      this.pollPhoneHandoff(handoff);
    } catch (error) {
      this.ui.phoneQrPlaceholder.hidden = true;
      this.ui.phoneStatus.textContent = "Could not create the phone link";
      this.showError(error.message || "Phone upload could not be started.");
      this.emit("error", { error: error, phase: "phone-handoff" });
    }
  };

  RoomAiInstance.prototype.pollPhoneHandoff = async function (handoff) {
    if (this.destroyed || this.phoneHandoff !== handoff) return;
    if (new Date(handoff.expiresAt).getTime() <= Date.now()) {
      this.clearPhoneHandoff();
      if (this.currentView === "phone") {
        this.ui.phoneStatus.textContent = "This link has expired";
        this.showError("Choose “Use your phone” again to create a fresh link.");
      }
      return;
    }
    try {
      var status = await requestJson(handoff.statusUrl, {
        headers: { Authorization: "Bearer " + handoff.token },
      });
      if (this.destroyed || this.phoneHandoff !== handoff) return;
      if (status.status === "ready") {
        this.ui.phoneStatus.textContent = "Photo received - opening it here…";
        var response = await fetch(handoff.photoUrl, {
          headers: { Authorization: "Bearer " + handoff.token },
        });
        if (!response.ok)
          throw sdkError(
            "The phone photo could not be downloaded.",
            "PHONE_PHOTO_DOWNLOAD_FAILED",
          );
        var blob = await response.blob();
        if (
          !/^image\/(jpeg|png|webp)$/.test(blob.type) ||
          !blob.size ||
          blob.size > this.maxUploadBytes
        ) {
          throw sdkError(
            "The phone sent an invalid room photo.",
            "PHONE_PHOTO_INVALID",
          );
        }
        this.setRoomPhoto(
          {
            blob: blob,
            width: status.width,
            height: status.height,
            aspectRatio: status.aspectRatio,
          },
          "phone",
        );
        this.emit("phone-photo-received", {
          width: status.width,
          height: status.height,
          aspectRatio: status.aspectRatio,
          byteSize: blob.size,
        });
        this.clearPhoneHandoff();
        this.showView("preview");
        return;
      }
      this.phonePollTimer = global.setTimeout(
        function () {
          this.pollPhoneHandoff(handoff);
        }.bind(this),
        1800,
      );
    } catch (error) {
      if (this.phoneHandoff !== handoff) return;
      this.clearPhoneHandoff();
      if (this.currentView === "phone") {
        this.ui.phoneStatus.textContent = "The connection was interrupted";
        this.showError(
          error.message || "The phone photo could not be received.",
        );
      }
      this.emit("error", { error: error, phase: "phone-handoff" });
    }
  };

  RoomAiInstance.prototype.getSession = async function (signal) {
    throwIfAborted(signal);
    if (
      this.session &&
      new Date(this.session.expiresAt).getTime() > Date.now() + 30000 &&
      this.session.productReference === this.productReference
    )
      return this.session;
    if (
      this.productSource === "ov25-configurator" &&
      !Number.isInteger(this.productId)
    ) {
      this.requestProductId();
      await wait(300, signal);
    }
    if (
      this.productSource === "ov25-configurator" &&
      !Number.isInteger(this.productId)
    )
      throw sdkError(
        "Wait for the configurator to finish loading, then try again.",
        "PRODUCT_NOT_READY",
      );
    if (!this.productReference)
      throw sdkError("A productReference is required.", "PRODUCT_NOT_READY");
    if (this.sessionPromise) {
      var sharedSession = await this.sessionPromise;
      throwIfAborted(signal);
      return sharedSession;
    }
    var instance = this;
    var requestedProductId = this.productId;
    var requestedProductReference = this.productReference;
    var requestedProductSource = this.productSource;
    var requestedAccountEpoch = this.accountEpoch;
    var sessionPromise = (async function () {
      var session;
      if (typeof instance.options.sessionProvider === "function") {
        session = await instance.options.sessionProvider({
          productId: requestedProductId,
          productReference: requestedProductReference,
          productSource: requestedProductSource,
          resolution: instance.options.resolution,
          origin: global.location.origin,
          signal: signal,
        });
      } else if (instance.options.sessionEndpoint) {
        var sessionUrl = new URL(
          String(instance.options.sessionEndpoint),
          global.location.href,
        );
        if (sessionUrl.origin !== global.location.origin) {
          throw sdkError(
            "sessionEndpoint must be on the retailer's own origin.",
            "INVALID_SESSION_ENDPOINT",
          );
        }
        session = await requestJson(sessionUrl.href, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "OrbitalRoomAI",
          },
          body: JSON.stringify({
            productId: requestedProductId,
            productReference: requestedProductReference,
            productSource: requestedProductSource,
            resolution: instance.options.resolution,
            origin: global.location.origin,
          }),
          signal: signal,
        });
      } else {
        session = await requestJson(
          instance.endpoint + "/api/configurator/room-ai/session",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              organizationId: instance.config.organizationId,
              productId: requestedProductId,
              productReference: requestedProductReference,
              productSource: requestedProductSource,
              resolution: instance.options.resolution,
              apiKey: instance.config.apiKey,
              deviceId: deviceMarker(instance.config.organizationId),
            }),
            signal: signal,
          },
        );
      }
      throwIfAborted(signal);
      if (
        instance.productId !== requestedProductId ||
        instance.productReference !== requestedProductReference ||
        instance.productSource !== requestedProductSource
      ) {
        throw sdkError(
          "The product changed while Room AI was opening.",
          "SESSION_PRODUCT_CHANGED",
        );
      }
      if (instance.accountEpoch !== requestedAccountEpoch) {
        throw sdkError(
          "The signed-in account changed while Prophecy was opening.",
          "SESSION_ACCOUNT_CHANGED",
        );
      }
      instance.session = assertBrowserSession(
        session,
        requestedProductId,
        requestedProductReference,
        requestedProductSource,
        instance.config.organizationId,
      );
      instance.adoptSessionOrganization(instance.session.organizationId);
      return instance.session;
    })().finally(function () {
      if (instance.sessionPromise === sessionPromise) {
        instance.sessionPromise = null;
      }
    });
    this.sessionPromise = sessionPromise;
    this.session = await this.sessionPromise;
    this.applyUploadLimit(this.session.upload.maxBytes);
    return this.session;
  };

  RoomAiInstance.prototype.applyUploadLimit = function (maxBytes) {
    var bytes = Number(maxBytes);
    if (!Number.isFinite(bytes) || bytes <= 0) return;
    this.maxUploadBytes = bytes;
    if (!this.ui) return;
    var constraint = this.ui.root.querySelector(".upload-constraint");
    if (constraint) {
      constraint.textContent =
        "JPEG, PNG or WebP · up to " +
        Math.floor(bytes / 1024 / 1024) +
        "MB";
    }
  };

  RoomAiInstance.prototype.captureProductViews = function () {
    if (!this.iframe || !this.iframe.contentWindow) {
      return Promise.reject(
        sdkError("An OV25 configurator iframe is not available.", "PRODUCT_CAPTURE_FAILED"),
      );
    }
    var instance = this;
    var requestId =
      this.productViewRequestPrefix + Date.now() + "-" + Math.random().toString(36).slice(2);
    return new Promise(function (resolve, reject) {
      var timeout = global.setTimeout(function () {
        instance.pendingProductViews.delete(requestId);
        reject(
          sdkError(
            "The configured product views took too long to prepare. Please try again.",
            "PRODUCT_CAPTURE_TIMEOUT",
          ),
        );
      }, 50000);
      instance.pendingProductViews.set(requestId, {
        resolve: function (blobs) {
          global.clearTimeout(timeout);
          resolve(blobs);
        },
        reject: function (error) {
          global.clearTimeout(timeout);
          reject(error);
        },
      });
      instance.iframe.contentWindow.postMessage(
        {
          type: "REQUEST_ROOM_AI_PRODUCT_VIEWS",
          payload: JSON.stringify({
            requestId: requestId,
            productId: instance.productId,
            productReference: instance.productReference,
          }),
        },
        instance.config.origin,
      );
    });
  };

  RoomAiInstance.prototype.getProductViewKey = function () {
    return (
      this.productSource +
      "|" +
      this.productReference +
      "|" +
      this.productVersion +
      "|" +
      this.selectionString
    );
  };

  RoomAiInstance.prototype.invalidateProductViews = function (
    preserveInFlight,
  ) {
    this.productViewBlobs = null;
    this.productViewKey = null;
    if (preserveInFlight && this.productViewPromise) {
      this.productViewPromiseKey = this.getProductViewKey();
      return;
    }
    this.productViewPromise = null;
    this.productViewPromiseKey = null;
  };

  RoomAiInstance.prototype.prepareProductViews = function () {
    var instance = this;
    var key = this.getProductViewKey();
    var productId = this.productId;
    var productReference = this.productReference;
    var productSource = this.productSource;
    if (this.productViewBlobs && this.productViewKey === key) {
      return Promise.resolve(this.productViewBlobs);
    }
    if (this.productViewPromise && this.productViewPromiseKey === key)
      return this.productViewPromise;

    var promise = (async function () {
      if (productSource === "external-images") {
        var externalBlobs = await Promise.all(
          instance.productImageSources.map(productImageSourceToBlob),
        );
        if (instance.getProductViewKey() !== key) {
          throw sdkError(
            "The product changed while its images were being prepared.",
            "PRODUCT_CAPTURE_STALE",
          );
        }
        instance.productViewBlobs = externalBlobs;
        instance.productViewKey = key;
        return externalBlobs;
      }
      var deadline = Date.now() + 60000;
      var failedAttempts = 0;
      while (Date.now() < deadline) {
        if (!Number.isInteger(instance.productId)) {
          instance.requestProductId();
          await wait(500);
          continue;
        }
        try {
          var blobs = await instance.captureProductViews();
          if (
            instance.productId !== productId ||
            instance.productReference !== productReference ||
            instance.productSource !== productSource
          ) {
            throw sdkError(
              "The configured product changed while its views were being prepared.",
              "PRODUCT_CAPTURE_STALE",
            );
          }
          instance.productViewBlobs = blobs;
          instance.productViewKey = instance.getProductViewKey();
          return blobs;
        } catch (error) {
          failedAttempts += 1;
          var canRetry = error && error.code === "PRODUCT_CAPTURE_NOT_READY";
          var canRetryFailure =
            error &&
            error.code === "PRODUCT_CAPTURE_FAILED" &&
            failedAttempts < 2;
          if ((!canRetry && !canRetryFailure) || Date.now() >= deadline)
            throw error;
          instance.requestProductId();
          await wait(900);
        }
      }
      throw sdkError(
        "The configured product views took too long to prepare. Please try again.",
        "PRODUCT_CAPTURE_TIMEOUT",
      );
    })();

    this.productViewPromise = promise;
    this.productViewPromiseKey = key;
    promise
      .catch(function (error) {
        if (instance.productViewPromise === promise) {
          console.warn("[room-ai-sdk] Product view preparation failed:", error);
        }
      })
      .finally(function () {
        if (instance.productViewPromise === promise) {
          instance.productViewPromise = null;
          instance.productViewPromiseKey = null;
        }
      });
    return promise;
  };

  RoomAiInstance.prototype.upload = async function (
    session,
    purpose,
    blob,
    signal,
  ) {
    throwIfAborted(signal);
    var authorization = "Bearer " + session.token;
    var signed = await requestJson(
      this.endpoint + "/api/configurator/room-ai/upload-url",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authorization,
        },
        body: JSON.stringify({
          purpose: purpose,
          contentType: blob.type,
          byteSize: blob.size,
        }),
        signal: signal,
      },
    );
    var response = await fetch(signed.uploadUrl, {
      method: "PUT",
      headers: signed.headers,
      body: blob,
      signal: signal,
    });
    if (!response.ok)
      throw sdkError(
        "A preview image could not be uploaded. Please try again.",
        "UPLOAD_FAILED",
      );
    return signed.key;
  };

  RoomAiInstance.prototype.generate = async function () {
    if (!this.roomPhoto || this.isGeneratingCurrent()) return;
    await this.whenConfigurationReady(4000);
    // The configuration can move while that resolves, so this is asked after.
    if (this.isGeneratingCurrent() || this.destroyed) return;
    var existing = this.designForCurrentConfiguration();
    if (existing) {
      this.showSavedDesigns();
      if (this.ui) this.showView("result");
      return;
    }
    if (!this.canStartGeneration()) {
      if (this.ui) {
        this.showError(
          "You can make " +
            this.maxConcurrent +
            " at a time. One of yours will be ready in a moment.",
        );
      }
      return;
    }
    var controller = new global.AbortController();
    var entry = this.beginGeneration(controller);
    this.generationController = controller;
    this.renderOverlay();
    var context = {
      productId: this.productId,
      productReference: this.productReference,
      productSource: this.productSource,
      selectionString: this.selectionString,
      queryString: this.currentProductQuery,
      productUrl:
        this.explicitProductUrl ||
        productUrlForPreview(this.currentProductQuery),
      sku: this.sku,
      // The page as it was when the picture was asked for, query string and
      // all, so the same configuration can be shown again.
      pageUrl: sameSiteProductUrl(global.location.href),
      roomPhoto: this.roomPhoto,
      accountEpoch: this.accountEpoch,
      historyEpoch: this.historyEpoch,
      productViewKey: this.getProductViewKey(),
    };
    if (this.ui) {
      if (this.carouselItems.length > 0) {
        this.showPendingSlide();
        this.showView("result");
      } else {
        this.showView("generating");
      }
      this.setGeneratingState(
        "Bringing it into your room",
        "This usually takes 20 to 30 seconds.",
      );
    }
    this.startGenerationClock();
    this.emit("generation-start", {
      productId: this.productId,
      productReference: context.productReference,
      productSource: context.productSource,
      selectionString: context.selectionString,
      aspectRatio: context.roomPhoto.aspectRatio,
      resolution: this.options.resolution || null,
    });
    try {
      var session = await this.getSession(controller.signal);
      if (
        this.productId !== context.productId ||
        this.getProductViewKey() !== context.productViewKey
      ) {
        throw sdkError(
          "The product changed before generation started.",
          "GENERATION_CONTEXT_CHANGED",
        );
      }
      var productBlobs = await abortable(
        this.prepareProductViews(),
        controller.signal,
      );
      var keys = await Promise.all(
        [context.roomPhoto.blob]
          .concat(productBlobs)
          .map(function (blob, index) {
            return this.upload(
              session,
              index === 0 ? "room" : "product",
              blob,
              controller.signal,
            );
        }, this),
      );
      throwIfAborted(controller.signal);
      if (
        this.productId !== context.productId ||
        this.getProductViewKey() !== context.productViewKey
      ) {
        throw sdkError(
          "The product changed before generation started.",
          "GENERATION_CONTEXT_CHANGED",
        );
      }
      console.info(
        "[prophecy] generating",
        JSON.stringify({
          productReference: context.productReference,
          selectionString: context.selectionString,
          productViews: keys.length - 1,
          aspectRatio: context.roomPhoto.aspectRatio,
          roomPhotoId: context.roomPhoto.historyId,
        }),
      );
      var started = await requestJson(
        this.endpoint + "/api/configurator/room-ai/generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + session.token,
          },
          body: JSON.stringify({
            roomImageKey: keys[0],
            productImageKeys: keys.slice(1),
            aspectRatio: context.roomPhoto.aspectRatio,
            resolution:
              this.options.resolution || session.generation.defaultResolution,
            selectionString: context.selectionString,
            productReference: context.productReference,
            productSource: context.productSource,
          }),
          signal: controller.signal,
        },
      );
      this.emit("generation-progress", {
        jobId: started.jobId,
        status: started.status,
        retryAfterMs: 0,
        productId: context.productId,
        productReference: context.productReference,
        productSource: context.productSource,
      });
      var result = await this.poll(
        started.pollingUrl,
        session.token,
        controller.signal,
        context.productId,
        context.productReference,
        context.productSource,
      );
      throwIfAborted(controller.signal);
      var resultDetail = {
        jobId: started.jobId,
        url: result.resultUrl,
        productId: context.productId,
        productReference: context.productReference,
        productSource: context.productSource,
        selectionString: context.selectionString,
        productUrl: context.productUrl,
        sku: context.sku,
        pageUrl: context.pageUrl,
        resolution: started.resolution,
        roomPhotoId: context.roomPhoto.accountId,
      };
      var contextStillCurrent =
        this.productId === context.productId &&
        this.productReference === context.productReference &&
        this.productSource === context.productSource &&
        this.selectionString === context.selectionString &&
        this.accountEpoch === context.accountEpoch;
      // Saved whatever is on screen by now. A shopper who changed the fabric
      // while this was running still paid for it, and it is still a preview of
      // their room: dropping it would lose the work and make going back to
      // that fabric generate the same picture a second time.
      if (!this.destroyed) {
        this.renderRoomResult(
          result.resultUrl,
          context.productUrl,
          started.jobId,
          context,
          contextStillCurrent,
        );
      }
      if (contextStillCurrent && !this.destroyed) {
        // Only if there is a dialog to show it in. Generating from the overlay
        // leaves it closed on purpose.
        if (this.ui) this.showView("result");
        this.flashFinished();
      }
      this.emit("generation-complete", resultDetail);
      if (
        this.options.history &&
        typeof this.options.history.saveResult === "function"
      ) {
        var instance = this;
        var history = this.options.history;
        this.enqueueHistory(
          async function (signal) {
            var persistedResult = Object.assign({}, resultDetail, {
              roomPhotoId: context.roomPhoto.accountId,
            });
            Object.defineProperty(persistedResult, "signal", {
              value: signal,
              enumerable: false,
            });
            var saved = await history.saveResult(persistedResult);
            throwIfAborted(signal);
            if (
              instance.destroyed ||
              context.historyEpoch !== instance.historyEpoch
            ) {
              return;
            }
            instance.emit("history-save", {
              kind: "result",
              id: saved && saved.id,
              jobId: started.jobId,
            });
          },
          context.historyEpoch,
        )
          .catch(function (historyError) {
            if (isAbortError(historyError)) return;
            instance.emit("history-error", {
              operation: "save-result",
              error: historyError,
            });
          });
      }
    } catch (error) {
      if (isAbortError(error) || this.destroyed) return;
      // Logged as well as shown: a generation started from the overlay has no
      // dialog to put an error in, and a silent failure there looks exactly
      // like nothing having happened.
      console.error("[prophecy] Room preview failed:", error);
      if (this.ui) this.showView("preview");
      if (error && error.code === "SIGN_IN_REQUIRED") {
        this.showError(
          error.message || "Sign in to keep generating room previews.",
        );
        this.emit("sign-in-required", {
          freeGenerations: this.freeGenerations,
          productId: context.productId,
          productReference: context.productReference,
          productSource: context.productSource,
        });
        return;
      }
      var isProductCaptureError =
        error &&
        typeof error.code === "string" &&
        error.code.indexOf("PRODUCT_CAPTURE_") === 0;
      this.showError(
        isProductCaptureError
          ? "We could not create the room preview. Please try again."
          : error.message ||
              "We could not create the room preview. Please try again.",
      );
      this.emit("generation-error", { error: error, phase: "generation" });
      this.emit("error", { error: error, phase: "generation" });
    } finally {
      // By its entry, not the key it started under: the key can move.
      if (this.pending.get(entry.key) === entry) this.pending.delete(entry.key);
      // Only stops if nothing else is still running.
      this.stopGenerationClock();
      if (!this.isGenerating()) this.clearPendingSlide();
      this.renderResultCarousel();
      this.renderOverlay();
      if (this.generationController === controller) {
        this.generationController = null;
      }
    }
  };

  RoomAiInstance.prototype.poll = async function (
    url,
    token,
    signal,
    productId,
    productReference,
    productSource,
  ) {
    var deadline =
      Date.now() + (Number(this.options.timeoutMs) || 4 * 60 * 1000);
    while (Date.now() < deadline) {
      var job = await requestJson(url, {
        headers: { Authorization: "Bearer " + token },
        signal: signal,
      });
      this.emit("generation-progress", {
        jobId: job.jobId,
        status: job.status,
        retryAfterMs: job.retryAfterMs || null,
        productId: productId,
        productReference: productReference,
        productSource: productSource,
      });
      if (job.status === "COMPLETED" && job.resultUrl) return job;
      if (job.status === "FAILED")
        throw sdkError(
          job.error || "We could not create this room preview.",
          "GENERATION_FAILED",
        );
      await wait(Number(job.retryAfterMs) || 4000, signal);
    }
    throw sdkError(
      "The room preview is taking longer than expected. Please try again.",
      "GENERATION_TIMEOUT",
    );
  };

  RoomAiInstance.prototype.reset = function (removeStoredPhoto, silent) {
    var hadRoomPhoto = Boolean(this.roomPhoto);
    this.roomPhoto = null;
    this.currentView = "upload";
    if (removeStoredPhoto !== false) {
      if (this.localHistoryEnabled) {
        deleteStoredRoomPhoto(this.roomPhotoStorageKey).catch(function () {});
        deleteStoredRoomPreviews(this.previewHistoryStorageKey);
      }
    }
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.previewUrl = null;
    if (this.ui) {
      this.ui.input.value = "";
      this.ui.cameraInput.value = "";
      this.ui.preview.removeAttribute("src");
      this.clearResultCarousel();
    }
    if (!silent && hadRoomPhoto) this.emit("photo-cleared", {});
  };

  RoomAiInstance.prototype.clearHistory = async function () {
    if (
      this.options.history &&
      typeof this.options.history.clear === "function" &&
      !Number.isInteger(this.config.organizationId)
    ) {
      await this.getSession();
    }
    var clearEpoch = this.beginHistoryEpoch();
    this.recentRoomPhotos = [];
    this.accountPreviews = [];
    this.reset(false);
    this.renderRecentRoomPhotos();
    if (this.localHistoryEnabled) {
      await Promise.all([
        deleteStoredRoomPhoto(this.roomPhotoStorageKey),
        withPhotoStore("readwrite", function (store) {
          return store.delete("recent:" + this.roomPhotoStorageKey);
        }.bind(this)),
      ]);
      deleteStoredRoomPreviews(this.previewHistoryStorageKey);
    }
    if (
      this.options.history &&
      typeof this.options.history.clear === "function"
    ) {
      var history = this.options.history;
      var organizationId = this.config.organizationId;
      await this.enqueueHistory(
        function (signal) {
          return history.clear({ organizationId: organizationId, signal: signal });
        },
        clearEpoch,
      );
    }
    this.emit("history-save", { kind: "clear" });
    return this;
  };

  RoomAiInstance.prototype.setAccountContext = async function (accountKey) {
    var nextAccountKey = normalizedAccountKey(accountKey);
    if (nextAccountKey === this.accountKey) return this;

    this.accountEpoch += 1;
    this.beginHistoryEpoch();
    if (this.historyLoadController) this.historyLoadController.abort();
    this.abortGenerations();
    this.session = null;
    this.sessionPromise = null;
    this.availability = "unchecked";
    this.availabilityError = null;
    this.accountKey = nextAccountKey;
    this.accountHistoryLoaded = false;
    this.accountPreviews = [];
    this.recentRoomPhotos = [];
    this.clearResultCarousel();
    this.reset(false, true);
    this.roomPhotoStorageKey = organizationStorageKey(
      "organization:",
      this.config.organizationId,
      this.accountKey,
    );
    this.previewHistoryStorageKey = organizationStorageKey(
      "orbital-room-ai-previews:organization:",
      this.config.organizationId,
      this.accountKey,
    );
    this.photoRestorePromise =
      this.localHistoryEnabled && Number.isInteger(this.config.organizationId)
      ? this.restoreRoomPhoto()
      : Promise.resolve();
    this.recentPhotosRestorePromise =
      this.localHistoryEnabled && Number.isInteger(this.config.organizationId)
      ? this.restoreRecentRoomPhotos()
      : Promise.resolve();
    await Promise.all([
      this.photoRestorePromise,
      this.recentPhotosRestorePromise,
    ]);
    if (this.options.history && this.accountKey && !this.destroyed) {
      this.accountHistoryLoaded = true;
      await this.refreshHistory();
    }
    if (this.ui) {
      this.renderRecentRoomPhotos();
      this.showView(this.roomPhoto ? "preview" : "upload");
    }
    this.emit("account-change", { authenticated: Boolean(this.accountKey) });
    if (this.launcher && !this.development) await this.checkAvailability();
    return this;
  };

  RoomAiInstance.prototype.setProductId = function (productId) {
    var next = Number(productId);
    if (!Number.isInteger(next))
      throw sdkError("productId must be an integer.", "INVALID_PRODUCT");
    if (next !== this.productId) {
      var previousProduct = this.productId;
      var previousReference = this.productReference;
      this.productId = next;
      this.productReference = String(next);
      this.productVersion += 1;
      this.session = null;
      this.sessionPromise = null;
      this.availability = "unchecked";
      this.availabilityError = null;
      this.invalidateProductViews();
      this.prepareRoomPhotoForReuse();
      this.emit("product-change", {
        previousProductId: previousProduct,
        previousProductReference: previousReference,
        productId: next,
        productReference: this.productReference,
        productSource: this.productSource,
        source: "host",
      });
      if (this.launcher && !this.development) this.checkAvailability();
      if (this.isOpen()) this.prepareProductViews().catch(function () {});
    }
    return this;
  };

  RoomAiInstance.prototype.setProduct = function (product) {
    if (!product || typeof product !== "object") {
      throw sdkError("setProduct requires a product object.", "INVALID_PRODUCT");
    }
    if (
      !this.options.sessionEndpoint &&
      typeof this.options.sessionProvider !== "function"
    ) {
      throw sdkError(
        "External products require a same-origin sessionEndpoint or sessionProvider.",
        "PARTNER_SESSION_REQUIRED",
      );
    }
    var sources = normalizeProductImageSources(product.images);
    var nextProductId = normalizedProductId(product.productId);
    var reference = normalizeProductReference(product.reference, nextProductId);
    if (!reference) {
      throw sdkError(
        "setProduct requires a non-empty reference.",
        "INVALID_PRODUCT_REFERENCE",
      );
    }
    var previousProductId = this.productId;
    var previousProductReference = this.productReference;
    this.productId = nextProductId;
    this.productReference = reference;
    this.productSource = "external-images";
    this.productImageSources = sources;
    this.explicitProductUrl = sameSiteProductUrl(product.url);
    this.selectionString = "";
    this.sku = "";
    this.productVersion += 1;
    this.session = null;
    this.sessionPromise = null;
    this.availability = "unchecked";
    this.availabilityError = null;
    this.invalidateProductViews();
    this.prepareRoomPhotoForReuse();
    this.emit("product-change", {
      previousProductId: previousProductId,
      previousProductReference: previousProductReference,
      productId: this.productId,
      productReference: this.productReference,
      productSource: this.productSource,
      source: "host",
    });
    if (this.launcher && !this.development) this.checkAvailability();
    if (this.isOpen()) this.prepareProductViews().catch(function () {});
    return this;
  };

  RoomAiInstance.prototype.destroy = function () {
    this.close();
    this.destroyed = true;
    this.accountEpoch += 1;
    this.beginHistoryEpoch();
    if (this.historyLoadController) this.historyLoadController.abort();
    this.abortGenerations();
    if (this.closeTimer) {
      global.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.clearPhoneHandoff();
    if (this.sceneSettleTimer) {
      global.clearTimeout(this.sceneSettleTimer);
      this.sceneSettleTimer = null;
    }
    this.stopGenerationClock();
    global.removeEventListener("message", this.handleMessage);
    this.pendingProductViews.forEach(function (pending) {
      pending.reject(sdkError("Room AI was closed."));
    });
    this.pendingProductViews.clear();
    this.productViewPromise = null;
    this.productViewPromiseKey = null;
    this.productViewBlobs = null;
    this.productViewKey = null;
    this.clearRecentPhotoUrls();
    this.clearLibraryRoomUrls();
    this.unmountOverlay();
    this.reset(false, true);
    this.emit("destroyed", this.getState());
    if (this.launcher) this.launcher.cleanup();
    if (this.ui) this.ui.host.remove();
    this.ui = null;
    this.listeners.clear();
  };

  function create(options) {
    return new RoomAiInstance(options);
  }
  function install(options) {
    if (!options || !options.button)
      throw sdkError("Prophecy.install requires a button option.");
    return create(options);
  }

  var publicApi = Object.freeze({
    version: VERSION,
    create: create,
    install: install,
  });
  global.Prophecy = publicApi;
  // Backwards-compatible alias for existing OV25 embeds during migration.
  global.OrbitalRoomAI = publicApi;

  // npm imports can execute inside classic Next.js/Webpack chunks, where
  // currentScript points to the host app. Only the standalone build auto-installs.
  var autoInstall =
    typeof __PROPHECY_AUTO_INSTALL__ === "undefined" || __PROPHECY_AUTO_INSTALL__;
  var loaderScript = autoInstall && global.document && global.document.currentScript;
  var loaderData = loaderScript && loaderScript.dataset;
  if (loaderData && loaderData.prophecyAuto !== "false") {
    // A bare script tag is a complete OV25 install: everything Prophecy needs
    // is already in the configurator's own URL. Attributes only ever override
    // discovery, so their absence is not a reason to stay switched off.
    var configuredByPage = Boolean(
      loaderData.prophecyButton ||
        loaderData.prophecyConfigurator ||
        loaderData.prophecySessionEndpoint ||
        loaderData.prophecyEndpoint ||
        loaderData.prophecyProductId ||
        loaderData.prophecyProductReference ||
        loaderData.prophecyProductImages ||
        loaderData.prophecyAuto === "true",
    );
    var developmentHost = isDevelopmentHost();
    var installed = false;
    var adoptive = false;
    var pageOwnsLauncher = false;

    /**
     * A page marks the element it wants Prophecy to open from. Single-page
     * retailers mount that button per route, so the choice is re-made whenever
     * the DOM changes: once a page has marked a launcher it keeps ownership,
     * and Prophecy stops offering its own.
     */
    var applyLauncher = function () {
      var instance = global.prophecy;
      if (!instance) return;
      var marked = document.querySelector("[data-prophecy-launcher]");
      if (marked) {
        pageOwnsLauncher = true;
        instance.useLauncher(marked);
      } else if (pageOwnsLauncher) {
        instance.releaseLauncher();
      } else if (!document.querySelector("[data-prophecy-auto-launcher]")) {
        instance.mountDefaultLauncher();
      }
    };

    /**
     * Whether there is anything yet to make a preview of: supplied images, or
     * a configurator on the page. Attributes alone are not one, so a tag that
     * carries a session endpoint still waits for its iframe to mount.
     */
    var hasProductSource = function () {
      if (loaderData.prophecyProductImages) return true;
      if (loaderData.prophecyConfigurator) {
        try {
          return Boolean(document.querySelector(loaderData.prophecyConfigurator));
        } catch (_) {
          // An invalid selector is a configuration error worth reporting.
          return true;
        }
      }
      return anyConfigurator(document, developmentHost);
    };

    var install = function () {
      if (installed) return true;
      // A second copy of the tag (a duplicated snippet, a tag manager firing
      // twice) must not mount a second launcher over the first.
      if (global.prophecy) {
        installed = true;
        return true;
      }
      // Most OV25 embeds mount their iframe after hydration, so the tag waits
      // for the configurator rather than failing on an empty document,
      // whatever attributes it carries.
      if (!hasProductSource()) return false;
      installed = true;
      try {
        var autoOptions = {
          configurator: loaderData.prophecyConfigurator || undefined,
          endpoint: loaderData.prophecyEndpoint || undefined,
          productId: loaderData.prophecyProductId
            ? Number(loaderData.prophecyProductId)
            : undefined,
          productReference: loaderData.prophecyProductReference || undefined,
          productImages: loaderData.prophecyProductImages
            ? jsonPayload(loaderData.prophecyProductImages)
            : undefined,
          productUrl: loaderData.prophecyProductUrl || undefined,
          sessionEndpoint: loaderData.prophecySessionEndpoint || undefined,
          accent: loaderData.prophecyAccent || undefined,
          resolution: loaderData.prophecyResolution || undefined,
          localHistory: loaderScript.hasAttribute("data-prophecy-local-history")
            ? loaderData.prophecyLocalHistory === "true"
            : undefined,
        };
        // Anything a tag cannot say, such as a function: the page sets
        // `window.prophecyOptions` before the script loads. Attributes win.
        var pageOptions =
          global.prophecyOptions && typeof global.prophecyOptions === "object"
            ? global.prophecyOptions
            : {};
        Object.keys(autoOptions).forEach(function (key) {
          if (autoOptions[key] === undefined) delete autoOptions[key];
        });
        autoOptions = Object.assign({}, pageOptions, autoOptions);
        if (loaderData.prophecyButton) {
          autoOptions.button = loaderData.prophecyButton;
          global.prophecy = publicApi.install(autoOptions);
        } else {
          // Placement is left to the page: it marks its own button, or gets
          // Prophecy's floating launcher if it never marks one.
          global.prophecy = publicApi.create(autoOptions);
          adoptive = true;
          applyLauncher();
          global.prophecy.mountOverlay();
        }
      } catch (error) {
        // A bare tag is expected to sit on pages with no configurator at all,
        // so only an explicitly configured install reports a failure.
        if (configuredByPage) {
          console.error("[prophecy] Declarative installation failed:", error);
        }
      }
      return true;
    };

    var watchDocument = function () {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        // Another copy of the runtime has taken over the page; stop watching
        // rather than racing it for the launcher.
        if (global.Prophecy !== publicApi) return observer.disconnect();
        if (scheduled) return;
        scheduled = true;
        // One coalesced pass per frame: the render commit that mounts the
        // configurator usually mounts the page's launcher button too.
        requestAnimationFrame(function () {
          scheduled = false;
          if (!install()) return;
          if (adoptive) applyLauncher();
          else observer.disconnect();
        });
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["src"],
      });
      if (install() && !adoptive) observer.disconnect();
    };

    if (global.document.readyState === "loading") {
      global.document.addEventListener("DOMContentLoaded", watchDocument, {
        once: true,
      });
    } else {
      watchDocument();
    }
  }
})(typeof window !== "undefined" ? window : globalThis);
